var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2998 0 0 2.2998 499.9934 499.9934)",
    id: 328782
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -108.145 -49.87)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-141.855, -200.13)",
    d: "M 238.395 341.53 H 45.305 c -3.15 -0.005 -5.7 -2.56 -5.7 -5.71 V 64.39 c 0.027 -3.13 2.57 -5.655 5.7 -5.66 h 193.09 c 3.153 0 5.71 2.556 5.71 5.71 l 0 0 v 271.38 C 244.105 338.974 241.548 341.53 238.395 341.53 z M 45.305 58.93 c -3.012 0.006 -5.45 2.448 -5.45 5.46 v 271.43 c 0 3.012 2.438 5.454 5.45 5.46 h 193.09 c 3.013 -0.005 5.454 -2.447 5.46 -5.46 V 64.39 c -0.006 -3.013 -2.447 -5.455 -5.46 -5.46 H 45.305 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 108.145 -49.87)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-358.145, -200.13)",
    d: "M 454.705 341.53 h -193.1 c -3.151 -0.005 -5.705 -2.559 -5.71 -5.71 V 64.39 c 0.033 -3.132 2.578 -5.655 5.71 -5.66 h 193.1 c 3.126 0.011 5.663 2.534 5.69 5.66 v 271.43 C 460.395 338.966 457.851 341.519 454.705 341.53 z M 261.605 58.93 c -3.013 0.006 -5.455 2.447 -5.46 5.46 v 271.43 c 0.005 3.013 2.447 5.454 5.46 5.46 h 193.1 c 3.013 -0.005 5.454 -2.447 5.46 -5.46 V 64.39 c -0.006 -3.013 -2.447 -5.455 -5.46 -5.46 H 261.605 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -175.605 142.335)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -20.605,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 41.21,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.665 140.335)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -20.665,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 41.33,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22.22 140.335)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -5,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 10,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -140.295 148.875)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -23.125,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 46.25,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32 142.205)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -10.8,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 21.6,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 65.665 142.205)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -13.965,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 27.93,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 183.11 146.435)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.22,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 62.44,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 132.525)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -250,
    y: -0.125,
    rx: 0,
    ry: 0,
    width: 500,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -70.465 28.5565)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.535, -278.5565)",
    d: "M 169.817 288.992 h 19.436 v -11.153 c 0 -5.367 -4.351 -9.718 -9.718 -9.718 l 0 0 c -5.367 0 -9.718 4.351 -9.718 9.718 V 288.992 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -70.349 28.355)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 8.199
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -70.233 28.355)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 6.58
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -70.2955 28.5035)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.7045, -278.5035)",
    d: "M 178.995 278.504 c 0 0.392 0.318 0.709 0.71 0.709 s 0.709 -0.318 0.709 -0.709 c 0 -0.392 -0.318 -0.71 -0.709 -0.71 S 178.995 278.112 178.995 278.504 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -71.299 26.317)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "1.085,2.448 4.095,-0.385 3.803,-0.696 1.076,1.871 -3.812,-2.448 -4.095,-2.128 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -167.4677 -61.5125)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 22.91,
    ry: 22.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -179.1135 -61.5175)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-70.8865, -188.4825)",
    d: "M 82.599 211.908 c -12.916 0 -23.425 -10.509 -23.425 -23.425 c 0 -12.917 10.509 -23.426 23.425 -23.426 v 1.031 c -12.348 0 -22.394 10.046 -22.394 22.395 c 0 12.348 10.046 22.394 22.394 22.394 V 211.908 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.6885 -61.5175)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-94.3115, -188.4825)",
    d: "M 82.599 211.908 v -1.031 c 12.348 0 22.395 -10.046 22.395 -22.394 c 0 -12.349 -10.047 -22.395 -22.395 -22.395 v -1.031 c 12.917 0 23.425 10.509 23.425 23.426 C 106.024 201.4 95.516 211.908 82.599 211.908 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -161.554 -73.184)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-88.446, -176.816)",
    d: "M 94.57 188.488 h -1.031 c 0 -7.593 -3.853 -17.751 -11.217 -22.476 l 0.556 -0.868 C 90.554 170.07 94.57 180.616 94.57 188.488 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -161.555 -50.539)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-88.445, -199.461)",
    d: "M 82.877 211.133 l -0.556 -0.868 c 7.365 -4.725 11.217 -14.883 11.217 -22.476 h 1.031 C 94.57 195.662 90.554 206.208 82.877 211.133 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -173.2455 -73.189)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-76.7545, -176.811)",
    d: "M 71.66 188.483 H 70.63 c 0 -7.872 4.016 -18.418 11.691 -23.344 l 0.558 0.868 C 75.513 170.732 71.66 180.891 71.66 188.483 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -173.247 -50.544)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-76.753, -199.456)",
    d: "M 82.32 211.128 c -7.675 -4.926 -11.691 -15.472 -11.691 -23.344 h 1.031 c 0 7.592 3.853 17.75 11.217 22.476 L 82.32 211.128 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -167.4005 -61.517)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -0.5155,
    y: -22.91,
    rx: 0,
    ry: 0,
    width: 1.031,
    height: 45.82
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -167.4 -73.7205)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -19.392,
    y: -0.5155,
    rx: 0,
    ry: 0,
    width: 38.784,
    height: 1.031
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -167.4005 -61.1265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -22.8995,
    y: -0.5155,
    rx: 0,
    ry: 0,
    width: 45.799,
    height: 1.031
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -167.4005 -48.5435)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -18.8795,
    y: -0.5155,
    rx: 0,
    ry: 0,
    width: 37.759,
    height: 1.031
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 -1 0 105.2216 -137.1073)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.7845,
    y: -79.7255,
    rx: 0,
    ry: 0,
    width: 5.569,
    height: 159.451
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.653 -128.0745)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-304.653, -121.9255)",
    d: "M 317.989 115.676 h -26.673 v 5.725 v 1.049 v 5.725 h 13.337 v 0 c 0 -3.162 2.563 -5.725 5.725 -5.725 h 7.612 V 115.676 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 46.215 -128.0745)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-296.215, -121.9255)",
    d: "M 305.936 115.676 h -19.442 v 12.499 h 6.105 v 0 c 0 -3.162 2.563 -5.725 5.725 -5.725 h 7.612 V 115.676 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 155.7895 -128.0745)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-405.7895, -121.9255)",
    d: "M 392.453 115.676 h 26.673 v 5.725 v 1.049 v 5.725 H 405.79 v 0 c 0 -3.162 -2.563 -5.725 -5.725 -5.725 h -7.612 V 115.676 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 164.2265 -128.0745)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-414.2265, -121.9255)",
    d: "M 404.506 115.676 h 19.441 v 12.499 h -6.105 v 0 c 0 -3.162 -2.563 -5.725 -5.725 -5.725 h -7.611 V 115.676 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 128.9085 -158.46)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-3.4245,7.589 5.3805,-7.589 4.0325,-7.589 -5.3805,7.589 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 83.958 -158.52)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "3.371,7.589 -5.328,-7.589 -3.979,-7.589 5.328,7.589 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.558 -150.4225)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-0.876,-0.5085 -0.427,0.5085 0.876,0.5085 0.461,-0.5085 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 124.279 -150.4225)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "0.876,-0.5085 0.427,0.5085 -0.876,0.5085 -0.461,-0.5085 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.1315 -142.2725)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.7065,
    y: -1.6855,
    rx: 0,
    ry: 0,
    width: 5.413,
    height: 3.371
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 124.8445 -142.2725)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.7065,
    y: -1.6855,
    rx: 0,
    ry: 0,
    width: 5.413,
    height: 3.371
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 106.4605 -146.231)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-356.4605, -103.769)",
    d: "M 379.443 107.534 l -11.76 1.273 c -7.46 0.807 -14.985 0.807 -22.445 0 l -11.76 -1.273 v -7.298 l 9.55 -1.241 c 8.917 -1.159 17.947 -1.159 26.865 0 l 9.55 1.241 V 107.534 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.131 -145.9075)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-338.131, -104.0925)",
    d: "M 340.31 104.092 c 0 1.203 -0.975 2.179 -2.179 2.179 c -1.203 0 -2.179 -0.975 -2.179 -2.179 c 0 -1.203 0.975 -2.178 2.179 -2.178 C 339.334 101.914 340.31 102.889 340.31 104.092 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.131 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 1.303
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 99.774 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-349.774, -104.11)",
    d: "M 350.463 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 c -0.38 0 -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.309 -0.689 0.689 -0.689 C 350.155 103.421 350.463 103.729 350.463 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 102.229 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-352.229, -104.11)",
    d: "M 352.918 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 c -0.38 0 -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.309 -0.689 0.689 -0.689 C 352.61 103.421 352.918 103.729 352.918 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 104.685 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-354.685, -104.11)",
    d: "M 355.374 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 s -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.308 -0.689 0.689 -0.689 S 355.374 103.729 355.374 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 107.14 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-357.14, -104.11)",
    d: "M 357.829 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 s -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.308 -0.689 0.689 -0.689 S 357.829 103.729 357.829 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 109.595 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-359.595, -104.11)",
    d: "M 360.284 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 c -0.38 0 -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.308 -0.689 0.689 -0.689 C 359.975 103.421 360.284 103.729 360.284 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 112.05 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-362.05, -104.11)",
    d: "M 362.739 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 s -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.308 -0.689 0.689 -0.689 S 362.739 103.729 362.739 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 114.505 -145.89)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-364.505, -104.11)",
    d: "M 365.194 104.11 c 0 0.38 -0.309 0.689 -0.689 0.689 c -0.38 0 -0.689 -0.309 -0.689 -0.689 c 0 -0.38 0.308 -0.689 0.689 -0.689 C 364.886 103.421 365.194 103.729 365.194 104.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.2785 -113.097)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.7215, -136.903)",
    d: "M 133.463 131.761 v 6.04 c 3.895 0.311 7.44 1.855 10.247 4.244 l 4.27 -4.27 C 144.068 134.307 139.02 132.092 133.463 131.761 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -130.7485 -81.4355)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-119.2515, -168.5645)",
    d: "M 130.548 173.821 c -8.818 -0.704 -15.848 -7.734 -16.553 -16.553 h -6.04 c 0.725 12.148 10.446 21.868 22.593 22.593 V 173.821 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -130.7475 -106.9425)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-119.2525, -143.0575)",
    d: "M 113.995 154.353 c 0.705 -8.818 7.735 -15.848 16.554 -16.552 v -6.04 c -12.147 0.725 -21.867 10.446 -22.593 22.593 H 113.995 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -105.2155 -90.1515)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-144.7845, -159.8485)",
    d: "M 150.042 139.836 l -4.27 4.27 c 2.684 3.154 4.308 7.239 4.308 11.705 c 0 9.491 -7.317 17.267 -16.616 18.01 v 6.04 c 12.63 -0.754 22.641 -11.231 22.641 -24.051 C 156.104 149.681 153.812 144.089 150.042 139.836 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -84.1255 76.8995)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-165.8745, -326.8995)",
    d: "M 74.521 382.023 h 182.707 c 10.863 0 19.669 -8.806 19.669 -19.669 v -70.909 c 0 -10.863 -8.806 -19.669 -19.669 -19.669 H 74.521 c -10.863 0 -19.669 8.806 -19.669 19.669 v 70.909 C 54.851 373.217 63.658 382.023 74.521 382.023 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.4255 77.7135)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-177.5745, -327.7135)",
    d: "M 86.221 382.837 h 182.707 c 10.863 0 19.669 -8.806 19.669 -19.669 v -70.909 c 0 -10.863 -8.806 -19.669 -19.669 -19.669 H 86.221 c -10.863 0 -19.669 8.806 -19.669 19.669 v 70.909 C 66.552 374.031 75.358 382.837 86.221 382.837 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.078 53.5505)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-176.922, -303.5505)",
    d: "M 76.73 324.116 h 200.384 v -27.393 c 0 -7.587 -6.151 -13.738 -13.738 -13.738 H 90.468 c -7.587 0 -13.738 6.151 -13.738 13.738 V 324.116 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.078 100.2475)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-176.922, -350.2475)",
    d: "M 90.468 370.813 h 172.908 c 7.587 0 13.738 -6.151 13.738 -13.738 v -27.393 H 76.73 v 27.393 C 76.73 364.662 82.88 370.813 90.468 370.813 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -105.849 57.6675)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -14.2,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 28.4,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -88.013 57.6675)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.637,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 7.274,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -116.829 55.089)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -10.667,
    y: -19.299,
    rx: 0,
    ry: 0,
    width: 21.334,
    height: 38.598
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -103.088 55.089)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.084,
    y: -19.299,
    rx: 0,
    ry: 0,
    width: 6.168,
    height: 38.598
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.4415 57.6675)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.9935,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 17.987,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -110.3935 57.6675)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.0545,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 4.109,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -138.966 60.497)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -11.796,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 23.592,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -124.1495 60.497)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.0205,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 6.041,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -148.086 58.355)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.862,
    y: -16.033,
    rx: 0,
    ry: 0,
    width: 17.724,
    height: 32.066
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -136.6715 58.355)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5625,
    y: -16.033,
    rx: 0,
    ry: 0,
    width: 5.125,
    height: 32.066
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -153.057 60.497)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.608,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 17.216,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -142.735 60.497)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -1.705,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 3.41,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.472 102.8265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -14.2,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 28.4,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.3655 102.8265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.6375,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 7.275,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.452 100.248)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -10.667,
    y: -19.299,
    rx: 0,
    ry: 0,
    width: 21.334,
    height: 38.598
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.71 100.248)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.084,
    y: -19.299,
    rx: 0,
    ry: 0,
    width: 6.168,
    height: 38.598
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -114.359 102.8265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -14.2,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 28.4,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.5215 102.8265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.6375,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 7.275,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -125.338 100.248)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -10.667,
    y: -19.299,
    rx: 0,
    ry: 0,
    width: 21.334,
    height: 38.598
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -111.597 100.248)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.084,
    y: -19.299,
    rx: 0,
    ry: 0,
    width: 6.168,
    height: 38.598
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -33.0645 102.8265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.9935,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 17.987,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22.0165 102.8265)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.0545,
    y: -16.7205,
    rx: 0,
    ry: 0,
    width: 4.109,
    height: 33.441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -50.589 105.655)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -11.796,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 23.592,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.7715 105.655)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.0205,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 6.041,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.709 103.513)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.862,
    y: -16.033,
    rx: 0,
    ry: 0,
    width: 17.724,
    height: 32.066
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -48.2935 103.513)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5625,
    y: -16.033,
    rx: 0,
    ry: 0,
    width: 5.125,
    height: 32.066
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -64.679 105.655)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.608,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 17.216,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -54.357 105.655)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -1.705,
    y: -13.891,
    rx: 0,
    ry: 0,
    width: 3.41,
    height: 27.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 138.1365 69.6295)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-388.1365, -319.6295)",
    d: "M 443.89 256.929 L 443.89 256.929 H 332.383 l 0 0 c 0 5.583 3.222 10.167 7.312 10.418 c 11.983 0.737 30.418 3.323 36.264 12.366 c 10.897 16.856 9.842 76.066 -3.211 89.78 c -4.093 4.3 -16.024 12.837 -16.024 12.837 h 62.826 c 0 0 -11.149 -8.71 -15.023 -12.837 c -12.979 -13.826 -13.357 -73.002 -2.409 -89.78 c 5.617 -8.609 22.896 -11.389 34.49 -12.266 C 440.697 267.137 443.89 262.514 443.89 256.929 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 138.9955 28.1605)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-388.9955, -278.1605)",
    d: "M 346.195 267.899 c 11.326 1.238 24.9 4.291 29.763 11.814 c 1.439 2.226 2.664 5.207 3.686 8.709 h 18.728 c 1.049 -3.505 2.295 -6.487 3.745 -8.709 c 4.882 -7.481 18.568 -10.56 29.679 -11.814 H 346.195 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 156.623 -4.816)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-10.232,11.818 -11.748,-11.818 10.232,-11.818 11.748,11.818 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 145.041 -4.816)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "1.35,11.818 -0.166,-11.818 -1.35,-11.818 0.166,11.818 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 156.623 -4.816)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-8.146,9.409 -9.353,-9.409 8.145,-9.409 9.353,9.409 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 156.623 -4.8155)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-6.804,7.8595 -7.813,-7.8595 6.804,-7.8595 7.813,7.8595 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 129.446 -12.165)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "9.815,19.094 -12.265,19.094 -9.815,-19.094 12.265,-19.094 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 141.013 -12.165)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-1.752,19.094 -0.698,19.094 1.752,-19.094 0.698,-19.094 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 129.446 -12.1655)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "7.814,15.2005 -9.764,15.2005 -7.814,-15.2005 9.764,-15.2005 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 129.446 -12.165)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "6.527,12.698 -8.156,12.698 -6.527,-12.698 8.156,-12.698 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 130.3626 -15.8996)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-380.3626, -234.1004)",
    d: "M 378.557 236.563 L 378.557 236.563 c 0.998 1.361 2.615 1.361 3.612 0 l 0 0 c 0.997 -1.36 0.997 -3.566 0 -4.926 l 0 0 c -0.997 -1.36 -2.615 -1.36 -3.612 0 l 0 0 C 377.559 232.997 377.559 235.202 378.557 236.563 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 128.3154 -7.3665)",
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-378.3154, -242.6335)",
    d: "M 379.638 240.83 L 379.638 240.83 c -0.73 -0.996 -1.915 -0.996 -2.645 0 l 0 0 c -1.178 1.607 -0.344 4.354 1.323 4.354 l 0 0 C 379.981 245.184 380.816 242.436 379.638 240.83 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0002 -22.1281)",
    id: "Background_Simple_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-249.9998, -227.8719)",
    d: "M 104.442 342.546 c 3.582 9.68 12.586 17.231 22.584 19.798 c 15.046 3.863 30.024 -4.996 45.014 -9.069 c 26.635 -7.237 54.731 0.783 81.344 8.101 c 26.613 7.318 55.468 13.883 81.249 4.025 c 22.124 -8.46 38.361 -27.91 49.573 -48.774 c 21.307 -39.647 27.593 -85.519 30.714 -130.42 c 1.393 -20.034 2.159 -40.643 -4.166 -59.704 c -6.325 -19.061 -21.213 -36.494 -40.925 -40.333 c -18.924 -3.685 -38.057 5.573 -53.348 17.315 c -15.291 11.743 -28.547 26.264 -45.245 35.901 c -24.321 14.036 -53.996 16.38 -81.742 12.053 c -17.19 -2.681 -45.834 -35.252 -74.991 -23.213 C 83.46 141.045 69.938 249.298 104.442 342.546 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0002 -22.1281)",
    id: "Background_Simple_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.9
    },
    transform: " translate(-249.9998, -227.8719)",
    d: "M 104.442 342.546 c 3.582 9.68 12.586 17.231 22.584 19.798 c 15.046 3.863 30.024 -4.996 45.014 -9.069 c 26.635 -7.237 54.731 0.783 81.344 8.101 c 26.613 7.318 55.468 13.883 81.249 4.025 c 22.124 -8.46 38.361 -27.91 49.573 -48.774 c 21.307 -39.647 27.593 -85.519 30.714 -130.42 c 1.393 -20.034 2.159 -40.643 -4.166 -59.704 c -6.325 -19.061 -21.213 -36.494 -40.925 -40.333 c -18.924 -3.685 -38.057 5.573 -53.348 17.315 c -15.291 11.743 -28.547 26.264 -45.245 35.901 c -24.321 14.036 -53.996 16.38 -81.742 12.053 c -17.19 -2.681 -45.834 -35.252 -74.991 -23.213 C 83.46 141.045 69.938 249.298 104.442 342.546 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 160.07)",
    id: "path--inject-214"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(245,245,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 133.7442 103.5133)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-383.7442, -353.5133)",
    d: "M 391.114 335.668 c -10.005 7.715 -12.898 24.601 -13.4 36.505 c -0.046 1.085 -1.739 1.091 -1.693 0 c 0.532 -12.608 3.401 -29.61 14.238 -37.967 C 391.122 333.542 391.966 335.012 391.114 335.668 L 391.114 335.668 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.2842 97.3637)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-372.2842, -347.3637)",
    d: "M 367.89 327.034 c 2.551 -0.294 4.699 2.314 5.808 4.23 c 5.756 9.95 3.528 24.967 2.439 35.643 c -0.109 1.073 -1.803 1.085 -1.693 0 c 1.06 -10.391 2.99 -23.927 -1.704 -33.803 c -0.806 -1.695 -2.528 -4.646 -4.85 -4.378 C 366.81 328.851 366.819 327.158 367.89 327.034 L 367.89 327.034 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 117.5659 104.1099)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-367.5659, -354.11)",
    d: "M 361.689 340.703 c 10.703 -2.642 12.038 21.086 12.355 26.204 c 0.067 1.088 -1.626 1.084 -1.693 0 c -0.428 -6.923 -0.77 -16.843 -5.778 -22.398 c -1.012 -1.123 -2.771 -2.584 -4.434 -2.174 C 361.082 342.596 360.631 340.965 361.689 340.703 L 361.689 340.703 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 137.0583 108.959)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-387.0584, -358.959)",
    d: "M 393.407 352.217 c -8.847 -6.553 -11.727 10.667 -12.216 15.63 c -0.106 1.074 -1.8 1.085 -1.693 0 c 0.556 -5.631 1.411 -15.833 7.917 -18.199 c 2.23 -0.811 4.944 -0.301 6.846 1.108 C 395.126 351.397 394.283 352.867 393.407 352.217 L 393.407 352.217 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 114.5886 110.5419)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-364.5886, -360.5419)",
    d: "M 358.213 355.325 c 1.329 -1.344 3.371 -2.237 5.266 -1.919 c 5.397 0.906 6.895 9.049 7.714 13.276 c 0.206 1.064 -1.425 1.52 -1.632 0.45 c -0.706 -3.647 -4.107 -16.724 -10.151 -10.61 C 358.643 357.298 357.446 356.101 358.213 355.325 L 358.213 355.325 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 127.2855 138.3865)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-377.2855, -388.3865)",
    d: "M 390.083 410.823 h -25.595 c -4.49 -3.813 -7.348 -9.484 -7.348 -15.84 c 0 -7.258 4.079 -29.033 4.079 -29.033 h 32.133 c 0 0 4.079 21.775 4.079 29.033 C 397.431 401.339 394.573 407.01 390.083 410.823 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 148.2485 103.579)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-398.2485, -353.579)",
    d: "M 394.155 360.567 c -7.719 0 -15.271 -3.129 -16.87 -6.988 c -1.599 -3.859 3.363 -6.988 11.081 -6.988 c 2.549 0 5.074 0.347 7.378 0.943 c 1.811 -0.596 4.049 -0.943 6.598 -0.943 c 7.719 0 15.271 3.129 16.87 6.988 c 1.599 3.859 -3.362 6.988 -11.081 6.988 H 394.155 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 148.2485 103.579)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-398.2485, -353.579)",
    d: "M 394.155 360.567 c -7.719 0 -15.271 -3.129 -16.87 -6.988 c -1.599 -3.859 3.363 -6.988 11.081 -6.988 c 2.549 0 5.074 0.347 7.378 0.943 c 1.811 -0.596 4.049 -0.943 6.598 -0.943 c 7.719 0 15.271 3.129 16.87 6.988 c 1.599 3.859 -3.362 6.988 -11.081 6.988 H 394.155 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.2255 89.892)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-355.2256, -339.892)",
    d: "M 343.794 345.608 c -6.313 0 -8.872 -2.559 -5.716 -5.716 c 3.157 -3.157 10.834 -5.716 17.147 -5.716 c 2.085 0 3.75 0.283 4.945 0.771 c 2.17 -0.487 4.402 -0.771 6.487 -0.771 c 6.314 0 8.872 2.559 5.716 5.716 c -3.157 3.157 -10.833 5.716 -17.147 5.716 H 343.794 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 151.857 82.701)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-401.857, -332.701)",
    d: "M 401.857 339.892 c -7.943 0 -17.602 -3.219 -21.573 -7.191 c -3.971 -3.971 -0.752 -7.191 7.191 -7.191 c 2.623 0 5.431 0.357 8.161 0.97 c 1.504 -0.613 3.598 -0.97 6.221 -0.97 c 7.943 0 17.602 3.22 21.573 7.191 c 3.971 3.972 0.752 7.191 -7.191 7.191 H 401.857 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 151.857 82.701)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-401.857, -332.701)",
    d: "M 401.857 339.892 c -7.943 0 -17.602 -3.219 -21.573 -7.191 c -3.971 -3.971 -0.752 -7.191 7.191 -7.191 c 2.623 0 5.431 0.357 8.161 0.97 c 1.504 -0.613 3.598 -0.97 6.221 -0.97 c 7.943 0 17.602 3.22 21.573 7.191 c 3.971 3.972 0.752 7.191 -7.191 7.191 H 401.857 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 112.784 77.0115)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-362.784, -327.0115)",
    d: "M 357.699 330.607 c -3.971 0 -6.524 -1.61 -5.702 -3.596 c 0.823 -1.986 4.709 -3.595 8.68 -3.595 c 1.311 0 2.463 0.178 3.395 0.485 c 1.186 -0.307 2.485 -0.485 3.797 -0.485 c 3.971 0 6.524 1.61 5.702 3.595 c -0.823 1.986 -4.709 3.596 -8.68 3.596 H 357.699 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 112.784 77.0115)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-362.784, -327.0115)",
    d: "M 357.699 330.607 c -3.971 0 -6.524 -1.61 -5.702 -3.596 c 0.823 -1.986 4.709 -3.595 8.68 -3.595 c 1.311 0 2.463 0.178 3.395 0.485 c 1.186 -0.307 2.485 -0.485 3.797 -0.485 c 3.971 0 6.524 1.61 5.702 3.595 c -0.823 1.986 -4.709 3.596 -8.68 3.596 H 357.699 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.226 105.7785)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-355.226, -355.7785)",
    d: "M 353.119 359.374 c -3.971 0 -7.858 -1.61 -8.68 -3.595 c -0.823 -1.986 1.73 -3.596 5.702 -3.596 c 1.311 0 2.611 0.178 3.797 0.485 c 0.932 -0.307 2.083 -0.485 3.395 -0.485 c 3.972 0 7.858 1.61 8.68 3.596 c 0.823 1.986 -1.73 3.595 -5.702 3.595 H 353.119 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.226 105.7785)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-355.226, -355.7785)",
    d: "M 353.119 359.374 c -3.971 0 -7.858 -1.61 -8.68 -3.595 c -0.823 -1.986 1.73 -3.596 5.702 -3.596 c 1.311 0 2.611 0.178 3.797 0.485 c 0.932 -0.307 2.083 -0.485 3.395 -0.485 c 3.972 0 7.858 1.61 8.68 3.596 c 0.823 1.986 -1.73 3.595 -5.702 3.595 H 353.119 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 127.2855 117.966)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-377.2855, -367.966)",
    d: "M 360.491 369.982 c 0.432 -2.447 0.728 -4.032 0.728 -4.032 h 32.133 c 0 0 0.296 1.585 0.728 4.032 H 360.491 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 103.2905 90.2305)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-353.2905, -340.2305)",
    d: "M 359.094 336.337 c 0 0 -8.815 2.938 -11.607 7.787 C 347.487 344.124 347.928 337.071 359.094 336.337 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 111.395 76.4005)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-361.395, -326.4005)",
    d: "M 363.24 324.807 c 0 0 -2.295 1.277 -3.69 3.187 C 359.55 327.994 360.245 325.22 363.24 324.807 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 155.145 83.047)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-405.145, -333.047)",
    d: "M 397.431 327.994 c 0 0 9.552 3.495 15.428 10.106 C 412.859 338.1 408.302 328.907 397.431 327.994 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 152.427 103.1575)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-402.427, -353.1575)",
    d: "M 397.431 349.262 c 0 0 5.732 2.061 9.992 7.791 C 407.423 357.053 405.657 350.432 397.431 349.262 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.34 106.022)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-355.34, -356.022)",
    d: "M 354.091 354.11 c 0 0 2.204 0.959 2.498 3.824 C 356.588 357.934 354.532 356.163 354.091 354.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -144.5276 -19.4746)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-105.4724, -230.5254)",
    d: "M 107.549 221.004 c 0.667 -1.314 2.19 -2.074 3.574 -1.785 c 1.384 0.29 2.518 1.605 2.661 3.089 c 0.979 -0.732 2.379 -0.769 3.391 -0.089 c 1.012 0.68 1.576 2.035 1.365 3.283 c 1.104 -0.891 2.913 -0.523 3.625 0.737 c 0.712 1.261 0.159 3.119 -1.107 3.723 c 0.862 0.062 1.601 0.922 1.578 1.834 c -0.023 0.913 -0.804 1.73 -1.668 1.744 c 0.873 0.02 1.676 0.788 1.782 1.704 c 0.106 0.916 -0.499 1.866 -1.343 2.107 c 0.887 0.394 1.111 1.852 0.388 2.522 c -0.723 0.671 -2.061 0.246 -2.315 -0.735 c -0.135 0.283 -0.553 0.349 -0.761 0.12 c -0.208 -0.229 -0.128 -0.668 0.146 -0.799 c -0.399 0.563 -1.42 0.302 -1.531 -0.392 c 0.3 1.607 -1.617 3.118 -2.988 2.356 c 0.396 0.671 -0.163 1.608 -0.885 1.817 c -0.722 0.209 -1.483 -0.086 -2.16 -0.421 c -0.678 -0.335 -1.37 -0.725 -2.119 -0.715 c -0.656 0.009 -1.267 0.326 -1.895 0.528 c -1.994 0.639 -4.301 0.031 -5.776 -1.525 c -1.037 1.392 -3.493 1.017 -4.116 -0.627 c -0.16 0.789 -0.858 1.42 -1.62 1.465 c -0.762 0.045 -1.522 -0.5 -1.764 -1.265 c -0.016 0.352 -0.031 0.703 -0.047 1.055 c -1.437 0.34 -2.857 -1.515 -2.241 -2.93 c -1.026 0.019 -1.997 -0.867 -2.129 -1.942 c -0.132 -1.076 0.592 -2.195 1.588 -2.454 c -1.691 -0.475 -2.981 -2.228 -2.999 -4.077 c -0.019 -1.849 1.236 -3.631 2.917 -4.144 c 0.663 -0.202 1.441 -0.197 1.97 0.27 c 0.529 0.467 0.6 1.494 0.009 1.87 c -0.508 -1.658 0.246 -3.644 1.697 -4.472 c 1.451 -0.827 3.436 -0.402 4.467 0.958 c -0.503 -0.705 -0.512 -1.757 -0.023 -2.472 c 0.49 -0.715 1.439 -1.034 2.229 -0.749 c 0.197 -1.139 1.331 -1.999 2.415 -1.831 c 1.084 0.168 1.937 1.336 1.816 2.487 c 0.125 -0.961 1.619 -1.243 2.05 -0.386 C 108.336 220.691 107.549 221.004 107.549 221.004 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -143.6387 -17.9022)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-106.3613, -232.0978)",
    d: "M 107.147 231.705 c 0.443 -0.308 1.003 -0.474 1.533 -0.368 c 0.529 0.106 1.008 0.515 1.117 1.044 c 0.109 0.529 -0.22 1.134 -0.745 1.261 c -0.638 0.154 -1.278 -0.372 -1.928 -0.28 c -0.232 0.033 -0.446 0.143 -0.672 0.203 c -0.935 0.25 -1.861 -0.361 -2.636 -0.939 c -0.273 -0.203 -0.552 -0.413 -0.734 -0.701 c -0.182 -0.287 -0.25 -0.673 -0.078 -0.967 c 0.239 -0.41 0.805 -0.47 1.276 -0.416 c 0.945 0.108 1.857 0.489 2.598 1.086 c -0.024 -0.148 -0.049 -0.296 -0.073 -0.444 L 107.147 231.705 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -156.051 -18.6405)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-93.949, -231.3595)",
    d: "M 93.564 230.903 c 0.254 -0.178 0.515 -0.359 0.816 -0.43 c 0.301 -0.071 0.656 -0.006 0.846 0.238 c 0.261 0.334 0.096 0.857 -0.236 1.122 c -0.331 0.265 -0.772 0.338 -1.191 0.403 c -0.431 0.067 -0.974 0.082 -1.187 -0.298 c -0.155 -0.277 -0.03 -0.643 0.201 -0.861 c 0.232 -0.217 0.545 -0.32 0.847 -0.418 L 93.564 230.903 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -137.0523 -24.3788)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-112.9477, -225.6213)",
    d: "M 115.022 223.838 c 0.865 0.362 1.533 1.162 1.735 2.077 c 0.061 0.276 0.052 0.624 -0.189 0.771 c -0.172 0.104 -0.391 0.061 -0.586 0.015 c -0.829 -0.197 -1.658 -0.394 -2.487 -0.59 c 0.397 0.153 0.803 0.311 1.12 0.595 c 0.317 0.284 0.53 0.724 0.426 1.136 c -0.122 0.484 -0.653 0.782 -1.152 0.775 c -0.499 -0.007 -0.964 -0.255 -1.37 -0.546 c -0.433 -0.311 -0.856 -0.741 -0.865 -1.274 c -0.008 -0.533 0.663 -1.027 1.072 -0.685 c -0.948 -0.258 -1.853 -0.67 -2.669 -1.215 c -0.295 -0.198 -0.586 -0.42 -0.772 -0.722 c -0.186 -0.303 -0.25 -0.703 -0.078 -1.014 c 0.85 -1.544 1.924 0.721 2.447 0.923 C 112.644 224.464 113.763 223.312 115.022 223.838 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -134.4465 -18.8799)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-115.5534, -231.1201)",
    d: "M 118.887 230.429 c 0.088 0.302 0.027 0.666 -0.218 0.862 c -0.246 0.196 -0.681 0.13 -0.794 -0.163 c 0.555 0.173 1.148 0.373 1.494 0.84 c 0.346 0.467 0.26 1.285 -0.292 1.465 c -0.345 0.113 -0.713 -0.057 -1.032 -0.231 c -0.901 -0.493 -1.761 -1.059 -2.569 -1.693 c 0.247 0.57 -0.347 1.216 -0.966 1.269 c -0.618 0.053 -1.196 -0.281 -1.727 -0.604 c -0.651 -0.395 -1.397 -0.999 -1.226 -1.741 c 0.149 -0.646 0.975 -0.932 1.61 -0.742 c 0.635 0.189 1.113 0.702 1.557 1.193 c -0.349 -0.508 0.147 -1.262 0.757 -1.345 c 0.593 -0.08 1.185 0.281 1.555 0.718 c -0.691 -0.379 -0.846 -1.368 0.08 -1.483 C 117.719 228.7 118.741 229.927 118.887 230.429 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -150.9199 -19.4741)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-99.08, -230.5259)",
    d: "M 99.91 228.209 c 0.522 -0.195 1.176 0.145 1.317 0.684 c 0.141 0.54 -0.264 1.156 -0.816 1.24 c 0.405 0.035 0.793 0.237 1.054 0.549 c 0.145 0.174 0.254 0.396 0.222 0.62 c -0.049 0.335 -0.405 0.554 -0.743 0.567 c -0.338 0.012 -0.66 -0.131 -0.968 -0.271 c 0.334 0.031 0.687 0.07 0.952 0.275 c 0.265 0.205 0.38 0.641 0.142 0.877 c -0.199 0.198 -0.526 0.165 -0.796 0.089 c -0.606 -0.17 -1.17 -0.487 -1.629 -0.917 c -0.345 0.382 -0.856 0.658 -1.364 0.575 c -0.508 -0.083 -0.939 -0.624 -0.78 -1.113 c 0.113 -0.349 0.479 -0.569 0.843 -0.613 c 0.365 -0.044 0.73 0.056 1.079 0.169 c -0.357 -0.254 -0.737 -0.537 -0.867 -0.956 c -0.131 -0.418 0.152 -0.98 0.59 -0.947 c 0.492 0.038 0.743 0.708 1.131 0.949 C 99.757 229.536 98.86 228.601 99.91 228.209 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -142.1527 -22.0607)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-107.8473, -227.9392)",
    d: "M 108.77 226.163 c 0.559 0.379 0.753 1.126 0.714 1.8 c -0.043 0.745 -0.381 1.54 -1.065 1.839 c -0.899 0.393 -2.022 -0.355 -2.187 -1.322 c -0.165 -0.967 0.47 -1.951 1.34 -2.403 C 107.573 226.078 108.211 225.785 108.77 226.163 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -147.866 -24.0147)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-102.1341, -225.9852)",
    d: "M 102.494 225.36 c -0.077 0.067 -0.154 0.133 -0.231 0.2 c 0.381 -0.483 1.186 -0.546 1.639 -0.129 c 0.452 0.417 0.455 1.224 0.006 1.644 c -0.45 0.42 -1.255 0.362 -1.64 -0.118 c -0.649 0.301 -1.505 0.184 -1.961 -0.367 c -0.456 -0.551 -0.353 -1.511 0.269 -1.864 c 0.622 -0.353 1.569 0.177 1.503 0.889 c 0.09 -0.1 0.18 -0.201 0.27 -0.301 L 102.494 225.36 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -154.6667 -22.0092)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-95.3332, -227.9909)",
    d: "M 95.566 226.479 c 0.444 0.437 0.906 0.904 1.069 1.506 c 0.163 0.602 -0.106 1.368 -0.71 1.521 c -0.6 0.153 -1.17 -0.342 -1.512 -0.859 c -0.309 -0.466 -0.545 -1.047 -0.367 -1.577 c 0.178 -0.53 0.942 -0.844 1.324 -0.436 L 95.566 226.479 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -145.756 -26.9743)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-104.244, -223.0257)",
    d: "M 105.549 222.843 c 0.227 -0.505 0.944 -0.681 1.413 -0.389 c 0.47 0.292 0.643 0.951 0.438 1.464 c -0.205 0.514 -0.732 0.862 -1.282 0.922 c -0.681 0.074 -1.486 -0.476 -1.333 -1.143 c -0.294 0.387 -0.821 0.54 -1.304 0.493 c -0.483 -0.048 -0.932 -0.267 -1.353 -0.509 c -0.572 -0.329 -1.181 -0.838 -1.121 -1.495 c 0.048 -0.523 0.554 -0.926 1.078 -0.975 c 0.523 -0.049 1.039 0.194 1.438 0.536 c 0.314 0.268 0.575 0.599 0.915 0.834 c 0.34 0.235 0.802 0.361 1.165 0.165 L 105.549 222.843 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -144.393 -4.9245)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-8.583,8.6505 8.583,8.6505 10.264,-8.6505 -10.264,-8.6505 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -144.393 -4.9245)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    points: "-8.583,8.6505 8.583,8.6505 10.264,-8.6505 -10.264,-8.6505 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -144.3075 -13.833)",
    id: "Plants"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-11.6785,1.151 11.6785,1.151 12.0985,-1.151 -12.0985,-1.151 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -122.8205 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-127.1795, -337.979)",
    d: "M 123.309 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 123.309 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -122.8205 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-127.1795, -337.979)",
    d: "M 123.309 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 123.309 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -163.9465 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-86.0535, -337.979)",
    d: "M 82.183 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 82.183 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -163.9465 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-86.0535, -337.979)",
    d: "M 82.183 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 82.183 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 56.0625 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-306.0625, -337.979)",
    d: "M 302.192 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 302.192 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 56.0625 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-306.0625, -337.979)",
    d: "M 302.192 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 302.192 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.9365 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-264.9365, -337.979)",
    d: "M 261.066 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 261.066 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.9365 87.979)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-264.9365, -337.979)",
    d: "M 261.066 264.582 h 7.524 l 0.217 144.058 c 0.002 1.51 -1.222 2.736 -2.732 2.736 l 0 0 c -1.494 0 -2.711 -1.199 -2.732 -2.693 L 261.066 264.582 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -54.2805 28.082)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-113.2365,13.5 113.2885,11.803 113.2885,-13.5 -113.2885,-13.5 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -146.919 28.082)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    points: "20.228,-13.308 20.65,13.177 -20.598,13.5 -20.65,-13.5 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.995 8.5065)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-197.005, -258.5065)",
    d: "M 317.834 258.507 L 317.834 258.507 c -0.005 -3.408 -1.271 -6.169 -2.834 -6.179 H 79.01 c -1.563 0.01 -2.829 2.771 -2.834 6.179 l 0 0 c 0.005 3.408 1.271 6.168 2.834 6.178 h 235.989 C 316.563 264.675 317.829 261.915 317.834 258.507 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.995 8.5065)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-197.005, -258.5065)",
    d: "M 317.834 258.507 L 317.834 258.507 c -0.005 -3.408 -1.271 -6.169 -2.834 -6.179 H 79.01 c -1.563 0.01 -2.829 2.771 -2.834 6.179 l 0 0 c 0.005 3.408 1.271 6.168 2.834 6.178 h 235.989 C 316.563 264.675 317.829 261.915 317.834 258.507 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -143.368 8.5065)",
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-106.632, -258.5065)",
    d: "M 137.088 258.507 L 137.088 258.507 c -0.005 -3.408 -1.271 -6.169 -2.834 -6.179 H 79.01 c -1.563 0.01 -2.829 2.771 -2.834 6.179 l 0 0 c 0.005 3.408 1.271 6.168 2.834 6.178 h 55.244 C 135.817 264.675 137.084 261.915 137.088 258.507 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.8895 -138.5905)",
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-251.8895, -111.4095)",
    d: "M 231.085 135.575 c -1.507 0 -2.733 -1.226 -2.733 -2.733 v -6.732 h -1.321 c -1.935 0 -3.51 -1.575 -3.51 -3.51 V 90.731 c 0.009 -1.927 1.576 -3.487 3.497 -3.487 c 0.005 0 0.011 0 0.016 0 h 49.729 c 1.927 0 3.495 1.568 3.495 3.495 V 122.6 c 0 1.936 -1.575 3.51 -3.51 3.51 h -32.498 l -11.524 8.911 C 232.252 135.379 231.671 135.575 231.085 135.575 z M 227.019 88.243 c -1.373 0 -2.493 1.114 -2.499 2.49 V 122.6 c 0 1.384 1.126 2.51 2.51 2.51 h 2.321 v 7.732 c 0 0.956 0.777 1.733 1.733 1.733 c 0.37 0 0.736 -0.124 1.031 -0.348 l 11.79 -9.117 h 32.84 c 1.384 0 2.51 -1.126 2.51 -2.51 V 90.738 c 0 -1.376 -1.119 -2.495 -2.495 -2.495 H 227.03 C 227.027 88.243 227.023 88.243 227.019 88.243 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.911 -166.36)",
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.113,
    y: -0.381,
    rx: 0,
    ry: 0,
    width: 6.226,
    height: 0.762
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -21.1225 -162.2565)",
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-228.8775, -87.7435)",
    d: "M 220.076 92.236 h -0.762 v -3.757 c 0.004 -2.888 2.347 -5.228 5.235 -5.228 h 13.892 v 0.762 H 224.55 c -2.468 0 -4.469 1.998 -4.473 4.466 V 92.236 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.354 -143.89)",
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.303
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.775 -143.89)",
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-251.775, -106.11)",
    d: "M 255.078 106.11 c 0 1.824 -1.479 3.303 -3.303 3.303 c -1.824 0 -3.303 -1.479 -3.303 -3.303 c 0 -1.824 1.479 -3.303 3.303 -3.303 C 253.599 102.807 255.078 104.285 255.078 106.11 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.903 -143.89)",
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.303
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -104.2755 -32.932)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-145.7245, -217.068)",
    d: "M 141.955 186.465 l 3.972 -0.182 l 5.575 61.57 h -4.216 c -2.106 -0.2 -2.598 -2.559 -3.181 -7.016 l -3.901 -42.984 C 139.291 187.659 141.033 186.465 141.955 186.465 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -104.2755 -32.932)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-145.7245, -217.068)",
    d: "M 141.955 186.465 l 3.972 -0.182 l 5.575 61.57 h -4.216 c -2.106 -0.2 -2.598 -2.559 -3.181 -7.016 l -3.901 -42.984 C 139.291 187.659 141.033 186.465 141.955 186.465 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.779 -32.9315)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-187.221, -217.0685)",
    d: "M 148.29 247.854 h 83.437 c 0.923 0 1.591 -0.864 1.493 -1.929 L 228 188.212 c -0.098 -1.065 -0.926 -1.929 -1.848 -1.929 h -83.437 c -0.922 0 -1.591 0.864 -1.493 1.929 l 5.22 57.713 C 146.54 246.99 147.367 247.854 148.29 247.854 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.722 -33.4595)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-35.789,24.0195 39.992,24.0195 35.789,-24.0195 -39.992,-24.0195 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.555 -33.386)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-187.445, -216.614)",
    d: "M 152.531 244.32 h 74.677 c 2.118 0 3.686 -1.717 3.5 -3.836 l -4.177 -47.74 c -0.185 -2.119 -2.053 -3.836 -4.172 -3.836 h -74.677 c -2.118 0 -3.686 1.717 -3.5 3.836 l 4.177 47.74 C 148.545 242.603 150.413 244.32 152.531 244.32 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.722 -33.4595)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-35.789,24.0195 39.992,24.0195 35.789,-24.0195 -39.992,-24.0195 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.722 -33.4595)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    points: "-35.789,24.0195 39.992,24.0195 35.789,-24.0195 -39.992,-24.0195 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -81.7 -33.385)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "4.993,-27.681 -9.809,27.681 -4.83,27.681 9.809,-27.681 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -71.567 -33.385)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "2.545,-27.681 -12.258,27.681 -2.381,27.681 12.258,-27.681 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.629 -43.151)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-154.371, -206.849)",
    d: "M 158.212 206.849 c 0.26 2.121 -1.249 3.841 -3.37 3.841 c -2.121 0 -4.052 -1.72 -4.312 -3.841 c -0.26 -2.121 1.249 -3.841 3.37 -3.841 C 156.021 203.008 157.952 204.728 158.212 206.849 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.629 -43.151)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-154.371, -206.849)",
    d: "M 158.212 206.849 c 0.26 2.121 -1.249 3.841 -3.37 3.841 c -2.121 0 -4.052 -1.72 -4.312 -3.841 c -0.26 -2.121 1.249 -3.841 3.37 -3.841 C 156.021 203.008 157.952 204.728 158.212 206.849 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.243 -42.44)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-154.757, -207.56)",
    d: "M 154.842 210.69 c 0.816 0 1.54 -0.257 2.109 -0.691 l -0.358 -1.199 c -0.136 -0.456 -0.573 -0.789 -1.037 -0.789 h -0.457 l -0.061 -0.497 c 0.472 -0.252 0.755 -0.814 0.674 -1.471 c -0.109 -0.891 -0.842 -1.613 -1.638 -1.613 c -0.796 0 -1.352 0.722 -1.243 1.613 c 0.081 0.657 0.501 1.219 1.035 1.471 l 0.061 0.497 h -0.457 c -0.463 0 -0.819 0.333 -0.843 0.789 l -0.064 1.199 C 153.238 210.433 154.025 210.69 154.842 210.69 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -81.567 -44.4195)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-168.433, -205.5805)",
    d: "M 160.947 206.12 c 5.035 0 10.069 0 15.104 0 c 0.694 0 0.563 -1.079 -0.132 -1.079 c -5.035 0 -10.069 0 -15.104 0 C 160.121 205.041 160.252 206.12 160.947 206.12 L 160.947 206.12 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -78.837 -41.7025)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-171.163, -208.2975)",
    d: "M 161.258 208.657 c 6.633 0 13.266 0 19.898 0 c 0.463 0 0.375 -0.719 -0.088 -0.719 c -6.633 0 -13.266 0 -19.898 0 C 160.707 207.938 160.795 208.657 161.258 208.657 L 161.258 208.657 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.947 -41.703)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-184.053, -208.297)",
    d: "M 184.9 208.297 c 0.057 0.468 -0.275 0.847 -0.743 0.847 c -0.468 0 -0.893 -0.379 -0.951 -0.847 c -0.057 -0.468 0.275 -0.847 0.743 -0.847 S 184.843 207.83 184.9 208.297 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.947 -41.703)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-184.053, -208.297)",
    d: "M 184.9 208.297 c 0.057 0.468 -0.275 0.847 -0.743 0.847 c -0.468 0 -0.893 -0.379 -0.951 -0.847 c -0.057 -0.468 0.275 -0.847 0.743 -0.847 S 184.843 207.83 184.9 208.297 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -64.6355 -55.3295)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-38.0785,-2.1495 -37.7025,2.1495 38.0785,2.1495 37.7025,-2.1495 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -100.101 -55.568)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-149.899, -194.432)",
    d: "M 150.766 194.432 c 0.042 0.479 -0.312 0.867 -0.791 0.867 c -0.479 0 -0.901 -0.388 -0.943 -0.867 c -0.042 -0.479 0.312 -0.867 0.791 -0.867 C 150.302 193.565 150.724 193.954 150.766 194.432 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -97.816 -55.568)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-152.184, -194.432)",
    d: "M 153.051 194.432 c 0.042 0.479 -0.312 0.867 -0.791 0.867 c -0.479 0 -0.901 -0.388 -0.943 -0.867 c -0.042 -0.479 0.312 -0.867 0.791 -0.867 C 152.587 193.565 153.009 193.954 153.051 194.432 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.531 -55.568)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-154.469, -194.432)",
    d: "M 155.336 194.432 c 0.042 0.479 -0.312 0.867 -0.791 0.867 c -0.479 0 -0.901 -0.388 -0.943 -0.867 c -0.042 -0.479 0.312 -0.867 0.791 -0.867 C 154.872 193.565 155.294 193.954 155.336 194.432 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.9355 0.3715)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-190.0645, -250.3715)",
    d: "M 232.592 252.72 h -85.055 c -1.001 0 -1.812 -0.811 -1.812 -1.812 v -1.073 c 0 -1.001 0.811 -1.812 1.812 -1.812 h 85.055 c 1.001 0 1.812 0.811 1.812 1.812 v 1.073 C 234.403 251.909 233.592 252.72 232.592 252.72 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.9355 0.3715)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-190.0645, -250.3715)",
    d: "M 232.592 252.72 h -85.055 c -1.001 0 -1.812 -0.811 -1.812 -1.812 v -1.073 c 0 -1.001 0.811 -1.812 1.812 -1.812 h 85.055 c 1.001 0 1.812 0.811 1.812 1.812 v 1.073 C 234.403 251.909 233.592 252.72 232.592 252.72 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.5575 0.3715)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-223.4425, -250.3715)",
    d: "M 263.793 252.72 h -80.7 c -2.001 0 -3.624 -1.622 -3.624 -3.624 v -1.073 h 87.947 v 1.073 C 267.417 251.098 265.794 252.72 263.793 252.72 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.5575 0.3715)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-223.4425, -250.3715)",
    d: "M 263.793 252.72 h -80.7 c -2.001 0 -3.624 -1.622 -3.624 -3.624 v -1.073 h 87.947 v 1.073 C 267.417 251.098 265.794 252.72 263.793 252.72 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -23.1685 -0.678)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-226.8315, -249.322)",
    d: "M 219.105 248.148 c 0 1.297 1.051 2.348 2.348 2.348 h 10.757 c 1.297 0 2.348 -1.051 2.348 -2.348 H 219.105 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60.793 -11.6705)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "38.063,2.3375 -37.654,2.3375 -38.063,-2.3375 37.654,-2.3375 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.1955 -11.583)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -26.301500000000004,
    y1: 0,
    x2: 26.301500000000004,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.1955 -11.583)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "26.3195,0.208 -26.2835,0.208 -26.3195,-0.208 26.2835,-0.208 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.8087 -11.552)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-218.1913, -238.448)",
    d: "M 218.607 238.654 c 0.017 0.194 -0.109 0.355 -0.407 0.355 c -0.156 0 -0.318 -0.047 -0.426 -0.128 l 0.073 -0.16 c 0.086 0.066 0.21 0.109 0.335 0.109 c 0.147 0 0.228 -0.065 0.219 -0.169 c -0.009 -0.105 -0.083 -0.172 -0.312 -0.172 h -0.267 l 0.004 -0.602 h 0.65 l 0.015 0.172 h -0.475 l -0.001 0.256 h 0.105 C 218.446 238.316 218.59 238.458 218.607 238.654 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.1595 -11.428)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-218.8405, -238.572)",
    d: "M 218.685 238.271 c -0.007 -0.079 0.047 -0.131 0.118 -0.131 c 0.071 0 0.134 0.052 0.141 0.131 c 0.007 0.076 -0.047 0.131 -0.118 0.131 C 218.755 238.402 218.691 238.347 218.685 238.271 z M 218.737 238.873 c -0.007 -0.079 0.047 -0.131 0.118 -0.131 c 0.071 0 0.134 0.052 0.141 0.131 c 0.007 0.076 -0.047 0.131 -0.118 0.131 C 218.807 239.004 218.744 238.949 218.737 238.873 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.446 -11.56)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-219.554, -238.44)",
    d: "M 219.092 238.44 c -0.032 -0.363 0.149 -0.569 0.411 -0.569 c 0.264 0 0.481 0.205 0.513 0.569 c 0.032 0.363 -0.149 0.569 -0.413 0.569 C 219.34 239.009 219.123 238.804 219.092 238.44 z M 219.809 238.44 c -0.023 -0.267 -0.139 -0.39 -0.29 -0.39 c -0.15 0 -0.244 0.123 -0.221 0.39 c 0.023 0.267 0.139 0.391 0.289 0.391 C 219.739 238.831 219.832 238.707 219.809 238.44 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -29.3835 -11.56)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-220.6165, -238.44)",
    d: "M 220.154 238.44 c -0.032 -0.363 0.149 -0.569 0.412 -0.569 c 0.264 0 0.481 0.205 0.513 0.569 c 0.032 0.363 -0.149 0.569 -0.413 0.569 C 220.403 239.009 220.186 238.804 220.154 238.44 z M 220.871 238.44 c -0.023 -0.267 -0.139 -0.39 -0.29 -0.39 c -0.15 0 -0.244 0.123 -0.221 0.39 c 0.023 0.267 0.139 0.391 0.289 0.391 C 220.801 238.831 220.895 238.707 220.871 238.44 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.552 -11.567)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-153.448, -238.433)",
    d: "M 153.903 238.82 l 0.015 0.174 h -0.815 l -0.012 -0.137 l 0.403 -0.417 c 0.098 -0.103 0.111 -0.167 0.106 -0.229 c -0.009 -0.101 -0.083 -0.16 -0.219 -0.16 c -0.107 0 -0.194 0.036 -0.249 0.115 l -0.154 -0.111 c 0.075 -0.115 0.223 -0.183 0.405 -0.183 c 0.24 0 0.405 0.122 0.423 0.318 c 0.009 0.107 -0.012 0.206 -0.153 0.349 l -0.271 0.282 H 153.903 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.8775 -11.428)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-154.1225, -238.572)",
    d: "M 153.967 238.271 c -0.007 -0.079 0.047 -0.131 0.118 -0.131 c 0.071 0 0.134 0.052 0.141 0.131 c 0.007 0.076 -0.047 0.131 -0.118 0.131 C 154.036 238.402 153.973 238.347 153.967 238.271 z M 154.019 238.873 c -0.007 -0.079 0.047 -0.131 0.118 -0.131 c 0.071 0 0.134 0.052 0.141 0.131 c 0.007 0.076 -0.047 0.131 -0.118 0.131 C 154.089 239.004 154.026 238.949 154.019 238.873 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.2198 -11.552)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-154.7802, -238.448)",
    d: "M 155.196 238.654 c 0.017 0.194 -0.11 0.355 -0.407 0.355 c -0.156 0 -0.318 -0.047 -0.426 -0.128 l 0.073 -0.16 c 0.086 0.066 0.21 0.109 0.335 0.109 c 0.147 0 0.228 -0.065 0.219 -0.169 c -0.009 -0.105 -0.083 -0.172 -0.312 -0.172 h -0.267 l 0.004 -0.602 h 0.649 l 0.015 0.172 h -0.475 l -0.001 0.256 h 0.105 C 155.035 238.316 155.179 238.458 155.196 238.654 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -94.243 -11.56)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-155.757, -238.44)",
    d: "M 155.295 238.44 c -0.032 -0.363 0.149 -0.569 0.411 -0.569 c 0.264 0 0.481 0.205 0.513 0.569 c 0.032 0.363 -0.149 0.569 -0.413 0.569 C 155.544 239.009 155.327 238.804 155.295 238.44 z M 156.012 238.44 c -0.023 -0.267 -0.139 -0.39 -0.29 -0.39 c -0.15 0 -0.244 0.123 -0.221 0.39 c 0.023 0.267 0.139 0.391 0.289 0.391 C 155.942 238.831 156.035 238.707 156.012 238.44 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.032 -11.583)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-223.968, -238.417)",
    d: "M 225.783 240.086 h -3.338 l -0.292 -3.338 h 3.338 L 225.783 240.086 z M 222.951 239.532 h 2.23 l -0.195 -2.23 h -2.23 L 222.951 239.532 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -77.6365 -11.5825)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "14.9855,-0.5765 -15.0865,-0.5765 -14.9855,0.5765 15.0865,0.5765 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.6035 -11.62)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-187.3965, -238.38)",
    d: "M 188.453 238.38 c 0.051 0.584 -0.381 1.057 -0.964 1.057 c -0.584 0 -1.098 -0.473 -1.149 -1.057 c -0.051 -0.584 0.381 -1.057 0.964 -1.057 C 187.888 237.323 188.402 237.796 188.453 238.38 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.6035 -11.62)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-187.3965, -238.38)",
    d: "M 188.453 238.38 c 0.051 0.584 -0.381 1.057 -0.964 1.057 c -0.584 0 -1.098 -0.473 -1.149 -1.057 c -0.051 -0.584 0.381 -1.057 0.964 -1.057 C 187.888 237.323 188.402 237.796 188.453 238.38 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.6696 -63.737)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(238,200,192)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.3304, -186.263)",
    d: "M 217.359 163.854 c 0 0 8.302 0.893 12.402 9.671 c 4.1 8.778 7.368 21.528 10.443 22.861 c 3.075 1.333 16.502 -11.889 16.502 -11.889 s -2.733 -8.746 1.367 -10.113 c 4.1 -1.367 3.28 -7.49 7.106 -6.205 c 3.827 1.285 6.013 6.752 5.74 9.758 c -0.273 3.006 -7.38 9.84 -7.38 9.84 s -12.847 22.867 -25.966 20.773 s -20.214 -32.737 -20.214 -32.737 S 213.669 163.375 217.359 163.854 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -23.6395 -57.8535)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-226.3605, -192.1465)",
    d: "M 221 187.072 c 2.876 7.758 5.249 13.369 10.721 18.344 c -5.926 -9.511 -5.28 -26.539 -5.28 -26.539 L 221 187.072 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -51.7215 -50.9726)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-198.2784, -199.0274)",
    d: "M 172.408 166.561 c 5.193 -1.475 9.922 -2.536 14.253 -3.296 l 0.162 0.137 l 0.248 0.242 l 2.112 1.611 l 5.734 3.455 l 4.714 0.741 l 4.56 -1.111 l 2.92 -4.065 l 0.534 -2.332 l 0.004 -0.071 c 7.332 0.49 12.156 2.077 14.88 3.33 c 1.694 0.779 2.811 2.437 2.919 4.299 c 0.16 2.765 0.641 7.856 2.038 16.099 c 1.901 11.218 -3.916 36.33 -6.171 45.379 c -0.51 2.046 -2.229 3.55 -4.319 3.825 c -17.905 2.36 -32.009 1.17 -38.85 0.247 c -2.511 -0.339 -4.404 -2.447 -4.433 -4.981 c -0.16 -14.375 -3.672 -46.472 -4.985 -58.024 C 168.446 169.566 170.006 167.242 172.408 166.561 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -51.7215 -50.9726)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-198.2784, -199.0274)",
    d: "M 172.408 166.561 c 5.193 -1.475 9.922 -2.536 14.253 -3.296 l 0.162 0.137 l 0.248 0.242 l 2.112 1.611 l 5.734 3.455 l 4.714 0.741 l 4.56 -1.111 l 2.92 -4.065 l 0.534 -2.332 l 0.004 -0.071 c 7.332 0.49 12.156 2.077 14.88 3.33 c 1.694 0.779 2.811 2.437 2.919 4.299 c 0.16 2.765 0.641 7.856 2.038 16.099 c 1.901 11.218 -3.916 36.33 -6.171 45.379 c -0.51 2.046 -2.229 3.55 -4.319 3.825 c -17.905 2.36 -32.009 1.17 -38.85 0.247 c -2.511 -0.339 -4.404 -2.447 -4.433 -4.981 c -0.16 -14.375 -3.672 -46.472 -4.985 -58.024 C 168.446 169.566 170.006 167.242 172.408 166.561 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -50.4933 -109.1032)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-199.5068, -140.8968)",
    d: "M 187.082 126.004 c -1.875 5.434 -4.975 11.357 -3.643 16.949 c 1.332 5.592 7.394 10.775 12.848 12.591 c 6.337 2.111 13.706 4.387 18.392 -0.373 c 2.317 -2.354 0.99 -7.091 -1.156 -9.602 c -2.147 -2.511 -5.949 -3.445 -9.014 -2.214 c 0.52 -2.678 0.053 -5.9 -0.535 -8.563 c -0.797 -3.607 -2.73 -7.104 -5.868 -9.055 C 194.968 123.786 188.286 122.512 187.082 126.004 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.832 -94.2575)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(238,200,192)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-197.168, -155.7425)",
    d: "M 189.08 162.859 c 3.71 -3.896 2.225 -21.402 2.225 -21.402 l 10.852 7.377 c 0 0 0.645 10.826 3.237 12.916 c 0.606 0.489 1.502 0.075 2.23 0.124 l -0.659 2.753 l -2.02 3.425 l -2.787 1.976 h -4.107 l -3.689 -1.054 l -4.215 -2.942 l -3.435 -2.768 C 187.506 163.124 188.545 163.421 189.08 162.859 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.8445 -99.1075)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-197.1555, -150.8925)",
    d: "M 203.109 156.079 c -7.137 -0.813 -10.422 -4.516 -11.907 -7.448 l 0.304 -2.925 l 10.852 7.377 L 203.109 156.079 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -49.2236 -113.9381)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(238,200,192)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-200.7763, -136.0619)",
    d: "M 187.053 134.472 c 2.286 9.017 3.067 12.869 8.559 16.668 c 8.265 5.727 18.835 0.934 19.29 -8.572 c 0.395 -8.566 -3.426 -21.914 -13.04 -23.792 c -6.859 -1.413 -13.565 3.002 -14.978 9.861 C 186.486 130.569 186.544 132.567 187.053 134.472 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -47.0711 -116.068)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-202.9288, -133.932)",
    d: "M 202.038 134.098 c 0.149 0.74 0.656 1.27 1.136 1.184 c 0.48 -0.086 0.767 -0.776 0.632 -1.516 c -0.135 -0.74 -0.657 -1.27 -1.136 -1.184 C 202.191 132.667 201.944 133.386 202.038 134.098 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38.69 -117.6373)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-211.31, -132.3627)",
    d: "M 210.426 132.523 c 0.148 0.754 0.656 1.27 1.136 1.184 c 0.48 -0.086 0.767 -0.776 0.632 -1.516 c -0.135 -0.74 -0.656 -1.269 -1.136 -1.17 C 210.578 131.12 210.291 131.783 210.426 132.523 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38.3075 -119.2345)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-211.6925, -130.7655)",
    d: "M 210.851 131.098 l 1.683 -0.853 C 212.534 130.245 211.888 131.816 210.851 131.098 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -40.126 -113.021)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,137,62)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-209.874, -136.979)",
    d: "M 208.095 134.359 c 0.987 1.568 2.184 2.994 3.558 4.237 c -0.669 0.687 -1.602 1.051 -2.56 0.998 L 208.095 134.359 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -49.9814 -118.9678)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-200.0186, -131.0322)",
    d: "M 198.346 133.053 c 0.194 -0.002 0.364 -0.132 0.416 -0.319 c 0.583 -1.34 1.697 -2.376 3.076 -2.858 c 0.235 -0.079 0.362 -0.332 0.285 -0.568 c -0.076 -0.229 -0.323 -0.353 -0.552 -0.277 c -0.005 0.001 -0.01 0.004 -0.015 0.005 c -1.662 0.568 -2.994 1.831 -3.648 3.461 c -0.065 0.232 0.07 0.474 0.303 0.539 h 0.001 C 198.253 133.054 198.3 133.06 198.346 133.053 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -39.6325 -122.546)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-210.3675, -127.454)",
    d: "M 212.208 128.177 c 0.162 -0.006 0.308 -0.096 0.387 -0.238 c 0.115 -0.216 0.035 -0.485 -0.179 -0.604 c -1.249 -0.738 -2.783 -0.805 -4.092 -0.18 c -0.21 0.103 -0.296 0.357 -0.193 0.567 c 0.005 0.01 0.011 0.021 0.016 0.031 c 0.114 0.213 0.379 0.293 0.591 0.179 c 0.002 -0.001 0.004 -0.002 0.006 -0.003 l 0 0 c 1.037 -0.451 2.227 -0.381 3.204 0.189 C 212.028 128.163 212.118 128.184 212.208 128.177 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -46.6965 -117.6016)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-203.3035, -132.3984)",
    d: "M 202.462 132.741 l 1.683 -0.853 C 204.145 131.889 203.5 133.404 202.462 132.741 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -39.6324 -127.4903)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-210.3675, -122.5097)",
    d: "M 215.759 116.782 c 2.433 1.829 3.619 4.854 2.884 7.505 c -0.346 1.247 -1.076 2.414 -1.13 3.706 c -0.054 1.292 0.957 2.812 2.437 2.796 c -2.047 0.226 -4.169 0.447 -6.173 -0.088 s -3.866 -2.047 -3.939 -3.86 c -0.027 -0.673 0.188 -1.328 0.228 -1.999 c 0.04 -0.671 -0.145 -1.425 -0.771 -1.839 c -1.106 -0.731 -2.576 0.055 -3.916 0.231 c -2.449 0.322 -4.872 -1.946 -4.568 -4.096 C 201.116 116.987 207.031 110.219 215.759 116.782 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60.4393 -125.3105)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-189.5607, -124.6896)",
    d: "M 206.682 113.682 c 3.274 1.809 12.071 10.879 -11.648 9.391 c 0 0 0.047 14.827 -7.41 16.839 l -19.512 -3.219 C 168.113 136.694 175.87 96.66 206.682 113.682 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -66.8843 -107.4173)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-183.1158, -142.5827)",
    d: "M 170.691 127.69 c -1.875 5.434 -4.975 11.357 -3.643 16.949 c 1.332 5.592 7.394 10.775 12.848 12.591 c 6.337 2.11 13.706 4.387 18.392 -0.373 c 2.317 -2.354 0.99 -7.091 -1.156 -9.602 c -2.147 -2.511 -5.948 -3.445 -9.014 -2.214 c 0.52 -2.678 0.053 -5.9 -0.535 -8.563 c -0.797 -3.607 -2.73 -7.104 -5.867 -9.055 C 178.578 125.472 171.896 124.198 170.691 127.69 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60.9101 -108.7987)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(238,200,192)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-189.0899, -141.2013)",
    d: "M 185.903 141.957 c 0.883 1.524 2.332 2.638 4.032 3.1 c 2.268 0.579 3.361 -1.46 2.695 -3.59 c -0.616 -1.911 -2.528 -4.516 -4.788 -4.194 c -1.634 0.286 -2.726 1.842 -2.44 3.476 C 185.479 141.184 185.649 141.596 185.903 141.957 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -43.8225 -105.7201)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-206.1775, -144.2799)",
    d: "M 209.874 142.182 c 0 0 -3.152 1.708 -7.39 0 c 0 0 -0.299 4.548 5.093 4.174 c 0.577 -0.04 2.296 -0.293 2.296 -0.293 S 209.421 144.206 209.874 142.182 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -44.4506 -106.7482)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-205.5495, -143.2518)",
    d: "M 202.724 143.746 c -0.282 -0.843 -0.241 -1.564 -0.241 -1.564 c 2.628 1.059 4.835 0.804 6.135 0.457 v 1.489 C 208.619 144.129 205.052 144.757 202.724 143.746 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -43.7695 -104.4717)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(193,59,55)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-206.2305, -145.5283)",
    d: "M 203.228 144.754 c 0.385 -0.047 0.78 -0.076 1.187 -0.076 c 1.954 0 3.676 0.583 4.818 1.477 c -0.551 0.077 -1.308 0.178 -1.656 0.202 C 205.168 146.523 203.899 145.707 203.228 144.754 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.7974 -76.1231)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-197.2026, -173.8768)",
    d: "M 209.7 161.872 c 0 0 -2.542 -0.858 -3.559 0 c 0 0 0.185 6.589 -5.13 7.421 c -5.315 0.832 -13.491 -6.378 -13.491 -6.378 s -1.531 -0.508 -3.565 0.555 l 20.915 22.793 C 213.26 177.438 209.7 161.872 209.7 161.872 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -45.1296 -60.4758)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(238,200,192)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-204.8705, -189.5242)",
    d: "M 171.411 188.343 c -2.027 -2.737 -6.131 -14.079 -1.634 -20.239 c 4.496 -6.16 31.636 30.923 31.636 30.923 c 4.577 -2.271 25.843 -9.402 25.843 -9.402 s 0.711 -7.424 3.839 -9.232 c 3.128 -1.809 4.57 -6.573 7.235 -3.754 c 2.665 2.819 5.776 10.636 1.678 13.599 c -4.098 2.962 -8.212 5.225 -8.212 5.225 s -16.371 11.533 -28.257 15.524 C 191.653 214.978 179.81 199.684 171.411 188.343 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -45.1296 -60.4758)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-204.8705, -189.5242)",
    d: "M 171.411 188.343 c -2.027 -2.737 -6.131 -14.079 -1.634 -20.239 c 4.496 -6.16 31.636 30.923 31.636 30.923 c 4.577 -2.271 25.843 -9.402 25.843 -9.402 s 0.711 -7.424 3.839 -9.232 c 3.128 -1.809 4.57 -6.573 7.235 -3.754 c 2.665 2.819 5.776 10.636 1.678 13.599 c -4.098 2.962 -8.212 5.225 -8.212 5.225 s -16.371 11.533 -28.257 15.524 C 191.653 214.978 179.81 199.684 171.411 188.343 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -45.1296 -60.4758)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-204.8705, -189.5242)",
    d: "M 171.411 188.343 c -2.027 -2.737 -6.131 -14.079 -1.634 -20.239 c 4.496 -6.16 31.636 30.923 31.636 30.923 c 4.577 -2.271 25.843 -9.402 25.843 -9.402 s 0.711 -7.424 3.839 -9.232 c 3.128 -1.809 4.57 -6.573 7.235 -3.754 c 2.665 2.819 5.776 10.636 1.678 13.599 c -4.098 2.962 -8.212 5.225 -8.212 5.225 s -16.371 11.533 -28.257 15.524 C 191.653 214.978 179.81 199.684 171.411 188.343 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.6945 -15.973)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-197.3055, -234.027)",
    d: "M 222.594 237.075 l -1.28 -6.096 c 0 0 -33.258 3.448 -47.441 0.286 l -1.856 5.81 H 222.594 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -61.9775 -103.249)",
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-188.0225, -146.751)",
    d: "M 189.826 146.751 c 0 0.996 -0.808 1.803 -1.804 1.803 s -1.803 -0.807 -1.803 -1.803 s 0.807 -1.803 1.803 -1.803 S 189.826 145.755 189.826 146.751 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 50.2825 -84.2753)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(160,39,36)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-300.2825, -165.7247)",
    d: "M 302.223 162.281 c -1.019 2.174 -2.324 4.202 -3.881 6.03 c 1.188 1.234 3.399 0.773 3.399 0.773 L 302.223 162.281 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 66.1358 -62.4545)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-316.1357, -187.5455)",
    d: "M 327.342 173.603 l -6.651 4.948 l -9.078 6.745 c 0.478 1.04 0.759 2.16 0.83 3.302 c 0.282 2.526 0.573 4.395 -5.052 5.86 c -1.219 0.272 -2.168 1.232 -2.426 2.454 c -0.241 1.488 0.643 3.299 5.805 4.262 c 5.001 0.821 10.134 0.022 14.65 -2.279 c 2.208 -1.065 2.227 -2.381 1.339 -4.619 C 324.088 187.91 325.542 179.86 327.342 173.603 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.1935 -88.2361)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-301.1935, -161.7639)",
    d: "M 300.457 161.579 c -0.197 0.784 -0.026 1.503 0.381 1.605 c 0.407 0.102 0.896 -0.451 1.092 -1.235 c 0.197 -0.784 0.026 -1.503 -0.381 -1.605 C 301.143 160.241 300.653 160.795 300.457 161.579 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.1388 -91.4205)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-304.1388, -158.5795)",
    d: "M 306.363 160.403 c -0.173 0 -0.342 -0.09 -0.434 -0.251 c -0.813 -1.419 -2.393 -2.36 -4.027 -2.396 c -0.275 -0.006 -0.494 -0.235 -0.488 -0.511 c 0.006 -0.272 0.229 -0.489 0.5 -0.489 c 0.004 0 0.008 0 0.011 0 c 1.978 0.044 3.89 1.183 4.872 2.899 c 0.138 0.24 0.055 0.545 -0.186 0.683 C 306.533 160.382 306.448 160.403 306.363 160.403 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 65.4532 -84.3219)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-315.4533, -165.6781)",
    d: "M 300.414 172.64 c 0.47 4.758 3.181 8.71 6.826 10.972 c 1.299 0.806 2.709 1.397 4.191 1.73 c 3.418 0.764 7.138 0.153 10.43 -2.331 c 5.788 -4.38 6.456 -10.315 8.468 -20.269 c 0.423 -2.015 0.399 -4.1 -0.061 -6.101 c -1.768 -7.599 -9.349 -12.323 -16.953 -10.57 C 302.948 148.545 299.512 163.267 300.414 172.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 59.4265 -65.6885)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-309.4265, -184.3115)",
    d: "M 307.24 183.612 c 1.299 0.806 2.709 1.397 4.191 1.73 l 0.182 -0.042 l -0.637 -2.019 C 310.976 183.282 310.124 184.767 307.24 183.612 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 66.7973 -90.166)",
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-316.7973, -159.834)",
    d: "M 333.227 169.895 c -1.678 3.436 -3.758 6.876 -6.928 9.009 c -1.173 0.794 -10.048 0.206 -10.048 0.206 c 0.085 -3.02 -3.731 -13.405 -5.575 -16.892 c -0.571 1.427 0.239 3.393 -0.491 4.71 c -0.983 -0.19 -18.786 -6.591 -10.944 -19.383 c 5.535 -9.029 20.403 -9.817 26.564 -0.913 c 2.607 -0.824 5.554 0.252 7.43 2.222 c 1.885 1.983 2.781 4.72 3.032 7.431 C 336.693 160.974 335.288 165.661 333.227 169.895 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.7435 -84.0562)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-312.7435, -165.9438)",
    d: "M 316.767 164.779 c -0.185 2.279 -1.205 4.41 -2.864 5.984 c -2.146 1.998 -4.822 -0.127 -5.156 -2.996 c -0.295 -2.572 0.953 -6.332 3.56 -7.23 C 314.914 159.64 316.983 161.96 316.767 164.779 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -19.4365 126.0525)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "0.2005,13.4815 -9.0175,8.9535 -2.2035,-13.4815 9.0175,-7.2175 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.242 116.453)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "8.244,-3.786 -3.564,-10.596 -8.244,5.577 2.411,10.596 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -33.9 141.9084)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-216.0999, -391.9084)",
    d: "M 220.997 383.224 l 10.554 4.869 c 0.376 0.151 0.557 0.633 0.407 1.085 l -3.452 10.256 c -0.441 1.089 -1.525 1.637 -2.444 1.236 c -3.641 -1.768 -5.307 -2.828 -9.945 -4.969 c -2.859 -1.316 -9.367 -4.417 -13.427 -5.891 c -4.06 -1.474 -2.381 -6.235 -0.518 -6.048 c 8.368 0.885 13.29 0.692 16.928 -0.585 C 219.735 382.947 220.403 382.963 220.997 383.224 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -33.8064 132.7929)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-216.1936, -382.7929)",
    d: "M 215.566 383.922 c 0.844 0.328 1.72 0.568 2.614 0.715 c 0.09 0.021 0.184 -0.018 0.232 -0.097 c 0.064 -0.066 0.087 -0.162 0.06 -0.25 c -0.21 -0.343 -2.128 -3.3 -3.469 -3.345 c -0.313 -0.021 -0.612 0.132 -0.779 0.397 c -0.313 0.37 -0.404 0.879 -0.239 1.335 C 214.343 383.271 214.905 383.714 215.566 383.922 z M 217.771 384.078 c -1.83 -0.442 -3.069 -0.964 -3.32 -1.596 c -0.09 -0.297 -0.013 -0.619 0.203 -0.843 c 0.077 -0.133 0.219 -0.215 0.373 -0.216 C 215.734 381.441 216.967 382.909 217.771 384.078 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.664 132.1773)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-218.336, -382.1772)",
    d: "M 218.193 384.64 c 0 0 0.066 0.016 0.105 0.026 c 0.084 -0.011 0.157 -0.06 0.199 -0.133 c 0.029 -0.118 1.43 -2.747 0.858 -4.07 c -0.135 -0.354 -0.435 -0.62 -0.804 -0.71 c -0.392 -0.156 -0.84 -0.022 -1.081 0.324 c -0.659 0.941 -0.084 3.518 0.617 4.481 C 218.11 384.599 218.148 384.628 218.193 384.64 z M 218.529 380.249 c 0.179 0.075 0.32 0.22 0.391 0.401 c 0.135 1.132 -0.097 2.277 -0.663 3.267 c -0.58 -1.095 -0.721 -2.369 -0.393 -3.564 c 0.032 -0.132 0.212 -0.242 0.551 -0.146 L 218.529 380.249 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 29.0015 72.3088)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-279.0015, -322.3089)",
    d: "M 300.918 273.536 c 0 0 -54.281 -9.338 -61.106 20.353 c -5.278 20.79 -7.827 29.249 -14.53 75.347 l 14.327 3.238 c 0 0 23.097 -47.22 24.445 -67.301 c 16.203 2.734 53.06 10.415 60.917 -3.296 c 3.929 -6.972 6.555 -14.602 7.75 -22.516 L 300.918 273.536 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 29.0015 72.3088)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-279.0015, -322.3089)",
    d: "M 300.918 273.536 c 0 0 -54.281 -9.338 -61.106 20.353 c -5.278 20.79 -7.827 29.249 -14.53 75.347 l 14.327 3.238 c 0 0 23.097 -47.22 24.445 -67.301 c 16.203 2.734 53.06 10.415 60.917 -3.296 c 3.929 -6.972 6.555 -14.602 7.75 -22.516 L 300.918 273.536 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.64 118.296)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "8.078,7.365 -10.275,0.942 -8.554,-7.365 10.275,0.282 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -56.1345 124.23)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-1.0975,11.985 -10.7755,6.614 -1.1565,-11.985 10.7755,-7.127 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -50.888 113.772)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "8.862,-2.396 -1.769,-10.928 -8.862,4.342 0.903,10.928 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -71.458 136.4307)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-178.542, -386.4307)",
    d: "M 184.079 378.488 l 9.688 6.422 c 0.349 0.207 0.454 0.71 0.236 1.135 l -4.976 9.609 c -0.602 1.009 -1.757 1.385 -2.604 0.849 c -3.329 -2.302 -4.814 -3.605 -9.07 -6.427 c -2.624 -1.736 -8.584 -5.795 -12.371 -7.871 c -3.787 -2.076 -1.402 -6.525 0.411 -6.056 c 8.135 2.151 13.029 2.711 16.819 2.005 C 182.874 378.022 183.532 378.14 184.079 378.488 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -70.6847 127.3844)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.3153, -377.3844)",
    d: "M 178.605 378.349 c 0.784 0.453 1.613 0.824 2.474 1.105 c 0.086 0.034 0.184 0.01 0.244 -0.061 c 0.073 -0.056 0.11 -0.147 0.098 -0.238 c -0.155 -0.371 -1.6 -3.586 -2.918 -3.835 c -0.306 -0.068 -0.625 0.037 -0.83 0.273 c -0.366 0.318 -0.534 0.808 -0.44 1.283 C 177.495 377.52 177.983 378.043 178.605 378.349 z M 180.761 378.84 c -1.741 -0.716 -2.886 -1.421 -3.038 -2.084 c -0.044 -0.307 0.082 -0.614 0.33 -0.802 c 0.096 -0.12 0.249 -0.18 0.402 -0.157 C 179.149 375.923 180.144 377.562 180.761 378.84 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.2706 127.0299)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-181.7294, -377.0299)",
    d: "M 181.092 379.46 c 0 0 0.063 0.026 0.1 0.041 c 0.084 0.002 0.164 -0.036 0.217 -0.101 c 0.047 -0.113 1.832 -2.497 1.468 -3.891 c -0.079 -0.371 -0.336 -0.679 -0.686 -0.824 c -0.363 -0.215 -0.827 -0.15 -1.118 0.155 c -0.795 0.83 -0.619 3.464 -0.074 4.523 C 181.016 379.406 181.05 379.441 181.092 379.46 z M 182.094 375.172 c 0.165 0.102 0.283 0.266 0.325 0.456 c -0.039 1.139 -0.444 2.236 -1.154 3.127 c -0.407 -1.17 -0.351 -2.451 0.155 -3.582 c 0.052 -0.125 0.246 -0.207 0.566 -0.06 L 182.094 375.172 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.4935 69.3263)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-252.4935, -319.3263)",
    d: "M 283.809 270.649 c -0.378 -0.064 -59.509 -16.059 -69.305 17.437 c -13.442 40.777 -23.416 75.381 -23.416 75.381 l 11.604 8.409 c 0 0 29.585 -40.94 33.979 -69.011 c 18.478 -2.083 62.639 14.107 70.493 0.407 c 6.431 -11.204 6.735 -27.546 6.735 -27.546 L 283.809 270.649 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.4935 69.3263)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-252.4935, -319.3263)",
    d: "M 283.809 270.649 c -0.378 -0.064 -59.509 -16.059 -69.305 17.437 c -13.442 40.777 -23.416 75.381 -23.416 75.381 l 11.604 8.409 c 0 0 29.585 -40.94 33.979 -69.011 c 18.478 -2.083 62.639 14.107 70.493 0.407 c 6.431 -11.204 6.735 -27.546 6.735 -27.546 L 283.809 270.649 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -51.5775 115.426)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "5.9855,8.61 -9.6975,-1.891 -7.1595,-8.61 9.6975,0.591 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.3041 -28.213)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-313.3041, -221.787)",
    d: "M 338.801 202.242 c -1.035 4.025 -2.211 7.95 -3.523 11.898 c -1.313 3.948 -2.812 7.884 -4.567 11.819 c -1.788 4.114 -4.002 8.029 -6.608 11.681 c -1.536 2.139 -3.372 4.046 -5.452 5.663 c -1.284 0.983 -2.699 1.783 -4.204 2.377 c -0.863 0.329 -1.757 0.572 -2.669 0.725 l -0.729 0.115 c -0.382 0.03 -0.799 0.065 -1.17 0.057 c -0.628 -0.01 -1.254 -0.081 -1.868 -0.212 c -0.912 -0.186 -1.802 -0.469 -2.654 -0.845 c -0.673 -0.291 -1.327 -0.624 -1.957 -0.998 c -1.062 -0.658 -2.083 -1.382 -3.054 -2.169 c -1.745 -1.369 -8.087 -11.396 -12.594 -18.349 l 5.37 -4.486 c 5.818 5.276 11.73 10.695 17.649 15.32 c 1.522 1.081 -4.894 -3.243 -3.463 -2.332 c 0.639 0.404 1.306 0.762 1.996 1.071 c 0.565 0.266 1.123 0.391 0.966 0.294 c -0.123 -0.037 -0.251 -0.057 -0.38 -0.059 c -0.143 -0.011 -0.287 -0.007 -0.43 0.011 l 0 0 c 0 0 0.107 -0.044 0.211 -0.106 c 0.333 -0.194 0.646 -0.421 0.933 -0.678 c 1.005 -0.941 1.893 -1.999 2.645 -3.152 c 1.889 -2.973 3.485 -6.122 4.765 -9.404 c 1.452 -3.488 2.648 -7.037 3.798 -10.693 c 1.151 -3.657 2.221 -7.37 3.184 -11.144 C 325.96 194.87 339.836 198.217 338.801 202.242 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.3041 -28.213)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.6
    },
    transform: " translate(-313.3041, -221.787)",
    d: "M 338.801 202.242 c -1.035 4.025 -2.211 7.95 -3.523 11.898 c -1.313 3.948 -2.812 7.884 -4.567 11.819 c -1.788 4.114 -4.002 8.029 -6.608 11.681 c -1.536 2.139 -3.372 4.046 -5.452 5.663 c -1.284 0.983 -2.699 1.783 -4.204 2.377 c -0.863 0.329 -1.757 0.572 -2.669 0.725 l -0.729 0.115 c -0.382 0.03 -0.799 0.065 -1.17 0.057 c -0.628 -0.01 -1.254 -0.081 -1.868 -0.212 c -0.912 -0.186 -1.802 -0.469 -2.654 -0.845 c -0.673 -0.291 -1.327 -0.624 -1.957 -0.998 c -1.062 -0.658 -2.083 -1.382 -3.054 -2.169 c -1.745 -1.369 -8.087 -11.396 -12.594 -18.349 l 5.37 -4.486 c 5.818 5.276 11.73 10.695 17.649 15.32 c 1.522 1.081 -4.894 -3.243 -3.463 -2.332 c 0.639 0.404 1.306 0.762 1.996 1.071 c 0.565 0.266 1.123 0.391 0.966 0.294 c -0.123 -0.037 -0.251 -0.057 -0.38 -0.059 c -0.143 -0.011 -0.287 -0.007 -0.43 0.011 l 0 0 c 0 0 0.107 -0.044 0.211 -0.106 c 0.333 -0.194 0.646 -0.421 0.933 -0.678 c 1.005 -0.941 1.893 -1.999 2.645 -3.152 c 1.889 -2.973 3.485 -6.122 4.765 -9.404 c 1.452 -3.488 2.648 -7.037 3.798 -10.693 c 1.151 -3.657 2.221 -7.37 3.184 -11.144 C 325.96 194.87 339.836 198.217 338.801 202.242 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36.082 -33.3943)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-286.082, -216.6057)",
    d: "M 293.524 220.117 l -5.135 -10.883 l -9.749 5.57 c 0 0 6.311 10.102 9.856 9.104 L 293.524 220.117 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.6579 -39.3651)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-281.658, -210.6349)",
    d: "M 280.432 206.655 l -4.476 1.841 c -1.125 0.463 -1.431 1.913 -0.59 2.791 l 3.315 3.458 l 9.749 -5.57 l -6.733 -2.54 C 281.289 206.482 280.836 206.488 280.432 206.655 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.4035 -5.6061)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-236.5965, -244.3939)",
    d: "M 243.585 240.156 l -10.504 -1.28 l -3.492 11.029 c 0 0 12.013 0.291 14.015 -2.943 L 243.585 240.156 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -21.9118 -5.6105)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,139,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-228.0881, -244.3895)",
    d: "M 225.247 242.629 l -1.963 4.193 c -0.589 1.257 0.275 2.712 1.66 2.797 l 4.644 0.285 l 3.492 -11.029 l -6.794 2.766 C 225.828 241.828 225.457 242.181 225.247 242.629 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.3713 -13.212)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-313.3713, -236.7879)",
    d: "M 342.141 201.662 c -0.473 -2.439 -4.1 -5.409 -6.565 -5.825 l -1.628 -0.275 c -2.844 -0.48 -6.426 -0.849 -9.934 -1.027 c -6.677 -0.381 -13.37 -0.384 -20.048 -0.01 c -3.09 0.281 -6.112 0.785 -8.526 1.251 c -0.031 0.007 -0.061 0.013 -0.092 0.02 c -2.818 0.604 -4.854 3.052 -4.94 5.934 c -0.225 7.551 -0.811 22.888 -2.163 38.021 c -1.055 11.807 -3.385 23.317 -4.436 31.324 l 48.919 8.254 c 3.299 -9.279 4.441 -17.665 7.492 -34.911 C 342.05 234.063 344.092 211.697 342.141 201.662 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.3713 -13.212)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.6
    },
    transform: " translate(-313.3713, -236.7879)",
    d: "M 342.141 201.662 c -0.473 -2.439 -4.1 -5.409 -6.565 -5.825 l -1.628 -0.275 c -2.844 -0.48 -6.426 -0.849 -9.934 -1.027 c -6.677 -0.381 -13.37 -0.384 -20.048 -0.01 c -3.09 0.281 -6.112 0.785 -8.526 1.251 c -0.031 0.007 -0.061 0.013 -0.092 0.02 c -2.818 0.604 -4.854 3.052 -4.94 5.934 c -0.225 7.551 -0.811 22.888 -2.163 38.021 c -1.055 11.807 -3.385 23.317 -4.436 31.324 l 48.919 8.254 c 3.299 -9.279 4.441 -17.665 7.492 -34.911 C 342.05 234.063 344.092 211.697 342.141 201.662 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.6054 -27.1687)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-271.6054, -222.8312)",
    d: "M 295.229 197.018 c 3.974 1.733 5.779 6.373 4.01 10.331 c -4.011 8.973 -10.697 23.189 -13.581 28.167 c -1.092 1.767 -2.185 3.522 -3.417 5.283 c -0.616 0.886 -1.302 1.764 -2.033 2.666 c -0.4 0.458 -0.721 0.879 -1.19 1.352 l -0.67 0.702 l -0.38 0.388 c -1.067 0.992 -2.341 1.735 -3.729 2.177 c -0.731 0.24 -1.478 0.43 -2.235 0.568 c -1.235 0.201 -2.484 0.302 -3.735 0.303 c -2.161 0.019 -17.026 1.334 -24.582 -1.315 l -0.395 -8.171 c 7.555 0.601 20.75 -3.491 22.447 -3.672 c 0.683 -0.082 1.359 -0.218 2.02 -0.408 c 0.216 -0.06 0.424 -0.146 0.618 -0.258 c 0.07 -0.003 -0.003 -0.081 -0.309 0.129 c -0.112 0.068 -0.214 0.151 -0.305 0.245 c 0 0 0.077 -0.108 0.111 -0.144 l 0.311 -0.373 c 0.2 -0.218 0.442 -0.577 0.675 -0.865 c 0.452 -0.624 0.914 -1.294 1.373 -2.023 c 0.908 -1.422 1.787 -2.994 2.654 -4.589 c 1.733 -3.19 3.329 -6.572 4.89 -9.987 c 1.106 -2.42 4.369 -9.783 7.135 -16.371 C 286.597 197.136 291.237 195.277 295.229 197.018 L 295.229 197.018 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 43.7615 -28.811)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-293.7615, -221.189)",
    d: "M 288.597 228.789 c 0.144 4.467 0.08 3.018 0.247 7.708 c 13.06 -18.066 9.692 -30.616 9.692 -30.616 L 288.597 228.789 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.6054 -27.1687)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.6
    },
    transform: " translate(-271.6054, -222.8312)",
    d: "M 295.229 197.018 c 3.974 1.733 5.779 6.373 4.01 10.331 c -4.011 8.973 -10.697 23.189 -13.581 28.167 c -1.092 1.767 -2.185 3.522 -3.417 5.283 c -0.616 0.886 -1.302 1.764 -2.033 2.666 c -0.4 0.458 -0.721 0.879 -1.19 1.352 l -0.67 0.702 l -0.38 0.388 c -1.067 0.992 -2.341 1.735 -3.729 2.177 c -0.731 0.24 -1.478 0.43 -2.235 0.568 c -1.235 0.201 -2.484 0.302 -3.735 0.303 c -2.161 0.019 -17.026 1.334 -24.582 -1.315 l -0.395 -8.171 c 7.555 0.601 20.75 -3.491 22.447 -3.672 c 0.683 -0.082 1.359 -0.218 2.02 -0.408 c 0.216 -0.06 0.424 -0.146 0.618 -0.258 c 0.07 -0.003 -0.003 -0.081 -0.309 0.129 c -0.112 0.068 -0.214 0.151 -0.305 0.245 c 0 0 0.077 -0.108 0.111 -0.144 l 0.311 -0.373 c 0.2 -0.218 0.442 -0.577 0.675 -0.865 c 0.452 -0.624 0.914 -1.294 1.373 -2.023 c 0.908 -1.422 1.787 -2.994 2.654 -4.589 c 1.733 -3.19 3.329 -6.572 4.89 -9.987 c 1.106 -2.42 4.369 -9.783 7.135 -16.371 C 286.597 197.136 291.237 195.277 295.229 197.018 L 295.229 197.018 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.6842 -84.4185)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(250,178,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-311.6842, -165.5815)",
    d: "M 309.923 161.967 c -1.588 1.413 -2.545 3.379 -2.658 5.464 c -0.129 2.767 2.561 3.516 4.899 2.218 c 2.119 -1.175 4.711 -4.027 3.73 -6.556 C 314.912 160.563 311.884 160.26 309.923 161.967 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.7015 -83.995)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-311.7015, -166.005)",
    d: "M 318.818 166.321 c -0.202 4.541 -2.941 8.108 -7.482 7.906 c -4.541 -0.202 -6.953 -3.997 -6.751 -8.538 c 0.202 -4.541 2.941 -8.108 7.482 -7.906 C 316.607 157.985 319.02 161.78 318.818 166.321 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.7015 -83.995)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.7
    },
    transform: " translate(-311.7015, -166.005)",
    d: "M 318.818 166.321 c -0.202 4.541 -2.941 8.108 -7.482 7.906 c -4.541 -0.202 -6.953 -3.997 -6.751 -8.538 c 0.202 -4.541 2.941 -8.108 7.482 -7.906 C 316.607 157.985 319.02 161.78 318.818 166.321 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.7011 -83.9955)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-311.7011, -166.0045)",
    d: "M 316.727 166.228 c -0.143 3.207 -2.077 5.726 -5.284 5.583 c -3.207 -0.143 -4.91 -2.823 -4.768 -6.03 c 0.143 -3.207 2.077 -5.726 5.284 -5.583 C 315.166 160.341 316.87 163.021 316.727 166.228 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.7011 -83.9955)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-311.7011, -166.0045)",
    d: "M 316.727 166.228 c -0.143 3.207 -2.077 5.726 -5.284 5.583 c -3.207 -0.143 -4.91 -2.823 -4.768 -6.03 c 0.143 -3.207 2.077 -5.726 5.284 -5.583 C 315.166 160.341 316.87 163.021 316.727 166.228 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.3045 -99.6227)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-319.3044, -150.3773)",
    d: "M 311.469 157.006 c 0.936 -3.82 4.615 -13.985 12.245 -15.418 c 0.753 -0.141 1.527 0.146 2.03 0.724 l 0.904 1.04 c 0.916 1.054 0.626 2.678 -0.601 3.344 c -3.045 1.653 -8.105 5.209 -10.701 11.534 c -0.301 0.733 -1.109 1.121 -1.875 0.919 l -0.852 -0.224 C 311.777 158.703 311.262 157.851 311.469 157.006 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.3045 -99.6227)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-319.3044, -150.3773)",
    d: "M 311.469 157.006 c 0.936 -3.82 4.615 -13.985 12.245 -15.418 c 0.753 -0.141 1.527 0.146 2.03 0.724 l 0.904 1.04 c 0.916 1.054 0.626 2.678 -0.601 3.344 c -3.045 1.653 -8.105 5.209 -10.701 11.534 c -0.301 0.733 -1.109 1.121 -1.875 0.919 l -0.852 -0.224 C 311.777 158.703 311.262 157.851 311.469 157.006 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.5115 32.621)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.2505,
    y: -13.868,
    rx: 0,
    ry: 0,
    width: 6.501,
    height: 27.736
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.5115 32.621)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.2505,
    y: -13.868,
    rx: 0,
    ry: 0,
    width: 6.501,
    height: 27.736
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.4823 19.9002)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-254.4823, -269.9002)",
    d: "M 276.59 277.219 c -14.307 -4.994 -29.884 -4.994 -44.192 0 c -2.97 1.12 -6.309 -0.153 -7.78 -2.965 l 0 0 c -1.326 -2.803 0.454 -6.431 4.059 -7.699 c 16.708 -5.838 34.903 -5.838 51.611 0 c 3.605 1.256 5.384 4.896 4.059 7.699 l 0 0 C 282.873 277.051 279.553 278.32 276.59 277.219 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.4823 19.9002)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-254.4823, -269.9002)",
    d: "M 276.59 277.219 c -14.307 -4.994 -29.884 -4.994 -44.192 0 c -2.97 1.12 -6.309 -0.153 -7.78 -2.965 l 0 0 c -1.326 -2.803 0.454 -6.431 4.059 -7.699 c 16.708 -5.838 34.903 -5.838 51.611 0 c 3.605 1.256 5.384 4.896 4.059 7.699 l 0 0 C 282.873 277.051 279.553 278.32 276.59 277.219 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.748 157.936)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-264.748, -407.936)",
    d: "M 269.807 407.936 c 0 2.794 -2.265 5.059 -5.059 5.059 c -2.794 0 -5.059 -2.265 -5.059 -5.059 c 0 -2.794 2.265 -5.059 5.059 -5.059 C 267.542 402.877 269.807 405.142 269.807 407.936 L 269.807 407.936 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 99.164 157.936)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-349.164, -407.936)",
    d: "M 344.105 407.936 c 0 2.794 2.265 5.059 5.059 5.059 c 2.794 0 5.059 -2.265 5.059 -5.059 c 0 -2.794 -2.265 -5.059 -5.059 -5.059 C 346.37 402.877 344.105 405.142 344.105 407.936 L 344.105 407.936 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.345 156.318)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-305.345, -406.318)",
    d: "M 300.286 406.318 c 0 2.794 2.265 5.059 5.059 5.059 c 2.794 0 5.059 -2.265 5.059 -5.059 c 0 -2.794 -2.265 -5.059 -5.059 -5.059 C 302.55 401.26 300.286 403.525 300.286 406.318 L 300.286 406.318 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 56.6171 148.069)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-306.6171, -398.069)",
    d: "M 360.185 401.143 c -0.233 1.176 -1.292 2.014 -2.492 1.979 l -52.757 -0.722 l -49.403 1.118 c -1.199 0.035 -2.259 -0.803 -2.48 -1.979 c -0.268 -1.339 0.605 -2.62 1.933 -2.888 l 26.978 -5.24 c 2.806 -0.524 5.635 -0.792 8.488 -0.792 h 28.992 c 2.841 0 5.682 0.268 8.476 0.792 l 30.32 4.855 C 359.568 398.524 360.441 399.804 360.185 401.143 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.932 124.43)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -8.972,
    y: -25.827,
    rx: 0,
    ry: 0,
    width: 17.944,
    height: 51.654
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.937 82.3655)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -6.396,
    y: -16.4905,
    rx: 0,
    ry: 0,
    width: 12.792,
    height: 32.981
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.9375 70.544)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "-6.3965,1.448 6.3965,4.669 6.3965,-4.669 -6.3965,-4.669 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.553 54.071)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-261.553, -304.071)",
    d: "M 299.792 292.411 v 23.32 h -68.098 c -4.619 0.011 -8.368 -3.738 -8.38 -8.357 c 0 -1.513 0.407 -2.981 1.174 -4.28 c 3.919 -6.618 11.022 -10.683 18.713 -10.683 H 299.792 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.553 54.071)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-261.553, -304.071)",
    d: "M 299.792 292.411 v 23.32 h -68.098 c -4.619 0.011 -8.368 -3.738 -8.38 -8.357 c 0 -1.513 0.407 -2.981 1.174 -4.28 c 3.919 -6.618 11.022 -10.683 18.713 -10.683 H 299.792 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.422 10.7015)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-304.422, -260.7015)",
    d: "M 313.495 206.048 c -0.166 0.757 -0.275 1.513 -0.329 2.281 l -7.484 107.026 h -10.333 l 7.484 -107.026 c 0.006 -0.079 0.012 -0.169 0.029 -0.248 L 313.495 206.048 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.422 10.7015)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-304.422, -260.7015)",
    d: "M 313.495 206.048 c -0.166 0.757 -0.275 1.513 -0.329 2.281 l -7.484 107.026 h -10.333 l 7.484 -107.026 c 0.006 -0.079 0.012 -0.169 0.029 -0.248 L 313.495 206.048 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.1265 65.809)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-360.1265, -315.809)",
    d: "M 360.996 315.747 v 0.124 h -1.739 C 359.855 315.871 360.42 315.826 360.996 315.747 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 93.3889 -18.457)",
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(139, 195, 74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-343.3889, -231.543)",
    d: "M 384.012 205.37 l 0.121 -12.716 c 0.036 -3.591 -1.217 -6.99 -3.519 -9.588 l -7.516 -8.47 l -2.686 -21.186 c -0.413 -3.298 -3.138 -5.68 -6.503 -5.68 h -18.668 c -3.004 0 -5.814 1.909 -6.984 4.755 l -9.409 22.79 l -15.56 9.181 c -3.981 2.349 -6.841 6.268 -7.806 10.695 l -2.838 12.976 l 0.218 -0.045 l 10.634 -2.033 c -0.166 0.757 -0.275 1.513 -0.329 2.281 l -7.484 107.026 h 58.567 c 0.599 0 1.166 -0.045 1.748 -0.124 h 0.011 c 5.898 -0.847 10.733 -5.884 11.157 -11.948 l 6.705 -95.89 c 0.048 -0.689 0.051 -1.378 0.009 -2.067 L 384.012 205.37 z M 335.057 197.284 l -18.213 1.728 l -0.796 0.079 l 2.521 -8.278 l 12.515 -5.839 l 4.168 -1.942 l 0.655 1.942 l 0.112 0.328 l 0.609 1.784 L 335.057 197.284 z M 370.841 197.499 h -0.011 l -2.23 -0.576 c -0.041 -0.7 -0.081 -1.423 -0.122 -2.135 c -0.231 -3.964 -0.421 -7.702 -0.421 -7.702 l 0.272 -1.31 l 0.565 -2.744 l 8.073 7.781 l -0.005 1.852 l -0.009 6.426 L 370.841 197.499 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.32ceeb78b0961f28c10f725c0c969adf.svg";
export { ForwardRef as ReactComponent };